import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import DailyPlanner from '../daily-planner/DailyPlanner';
import { db, COLLECTIONS } from '../../firebase/config';
import { collection, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { 
  BarChart3, 
  TrendingUp, 
  Users, 
  Building2, 
  CheckSquare, 
  Calendar,
  Target,
  Activity,
  PieChart,
  ArrowUp,
  ArrowDown,
  Minus,
  Filter,
  Download,
  RefreshCw,
  Clock,
  AlertTriangle,
  CheckCircle,
  PlayCircle,
  PauseCircle,
  Zap,
  Star,
  Award,
  Trophy,
  User,
  MessageSquare,
  Crown,
  FileText,
  Plus,
  Edit2,
  Eye,
  Sun,
  Moon,
  FolderOpen,
  RotateCcw,
  BookOpen,
  Settings,
  Bell,
  Lightbulb,
  ArrowLeft,
  Save,
  ChevronDown,
  X,
  ChevronLeft,
  ChevronRight,
  CalendarDays,
  Lock,
  Trash2,
  Check,
  Globe
} from 'lucide-react';

// בפונקציה תשתמש ב-RotateCcw במקום RotateCw
// פונקציית עזר לפעולות מהירות לפי תפקיד
// פונקציית עזר לפעולות מהירות לפי תפקיד - מותאם לסיידבר
const getQuickActionsByRole = (userRole) => {
  const roleActions = {
    'org_admin': [
      { icon: Calendar, label: 'תכנון יום', action: 'daily-planning' },
      { icon: Moon, label: 'סיכום יום', action: 'day-summary' },
      { icon: CheckSquare, label: 'ניהול משימות', action: 'tasks' },
      { icon: FolderOpen, label: 'ניהול פרויקטים', action: 'projects' },
      { icon: Building2, label: 'ניהול מחלקות', action: 'departments' },
      { icon: Users, label: 'ניהול צוותים', action: 'teams' },
      { icon: Calendar, label: 'זמינות הצוות', action: 'team-availability' },
      { icon: RotateCcw, label: 'שגרות יומיות', action: 'daily-routines' },
      { icon: Settings, label: 'ניהול מערכת', action: 'admin' }
    ],
    'ceo': [
      { icon: Calendar, label: 'תכנון יום', action: 'daily-planning' },
      { icon: Moon, label: 'סיכום יום', action: 'day-summary' },
      { icon: CheckSquare, label: 'ניהול משימות', action: 'tasks' },
      { icon: FolderOpen, label: 'ניהול פרויקטים', action: 'projects' },
      { icon: Building2, label: 'ניהול מחלקות', action: 'departments' },
      { icon: Users, label: 'ניהול צוותים', action: 'teams' },
      { icon: Calendar, label: 'זמינות הצוות', action: 'team-availability' },
      { icon: RotateCcw, label: 'שגרות יומיות', action: 'daily-routines' },
      { icon: Settings, label: 'ניהול מערכת', action: 'admin' }
    ],
    'deputy_ceo': [
      { icon: Calendar, label: 'תכנון יום', action: 'daily-planning' },
      { icon: Moon, label: 'סיכום יום', action: 'day-summary' },
      { icon: CheckSquare, label: 'ניהול משימות', action: 'tasks' },
      { icon: FolderOpen, label: 'ניהול פרויקטים', action: 'projects' },
      { icon: Building2, label: 'ניהול מחלקות', action: 'departments' },
      { icon: Users, label: 'ניהול צוותים', action: 'teams' },
      { icon: Calendar, label: 'זמינות הצוות', action: 'team-availability' },
      { icon: RotateCcw, label: 'שגרות יומיות', action: 'daily-routines' },
      { icon: Settings, label: 'ניהול מערכת', action: 'admin' }
    ],
    'dept_manager': [
      { icon: Calendar, label: 'תכנון יום', action: 'daily-planning' },
      { icon: Moon, label: 'סיכום יום', action: 'day-summary' },
      { icon: CheckSquare, label: 'ניהול משימות', action: 'tasks' },
      { icon: FolderOpen, label: 'ניהול פרויקטים', action: 'projects' },
      { icon: Building2, label: 'המחלקה שלי', action: 'my-department' },
      { icon: Users, label: 'הצוותים שלי', action: 'my-teams' },
      { icon: Calendar, label: 'זמינות הצוות', action: 'team-availability' },
      { icon: RotateCcw, label: 'שגרות יומיות', action: 'daily-routines' }
    ],
    'team_manager': [
      { icon: Calendar, label: 'תכנון יום', action: 'daily-planning' },
      { icon: Moon, label: 'סיכום יום', action: 'day-summary' },
      { icon: CheckSquare, label: 'ניהול משימות', action: 'tasks' },
      { icon: FolderOpen, label: 'ניהול פרויקטים', action: 'projects' },
      { icon: Users, label: 'הצוות שלי', action: 'my-team' },
      { icon: Calendar, label: 'זמינות הצוות', action: 'team-availability' },
      { icon: RotateCcw, label: 'שגרות יומיות', action: 'daily-routines' }
    ],
    'employee': [
      { icon: Calendar, label: 'תכנון יום', action: 'daily-planning' },
      { icon: Moon, label: 'סיכום יום', action: 'day-summary' },
      { icon: CheckSquare, label: 'המשימות שלי', action: 'my-tasks' },
      { icon: FolderOpen, label: 'הפרויקטים שלי', action: 'my-projects' },
      { icon: RotateCcw, label: 'שגרות יומיות', action: 'daily-routines' }
    ]
  };
  
  return roleActions[userRole] || roleActions['employee'];
};
const ManagerialDashboard = ({ onBackToDailyPlanner, openPlanner = false }) => {
  const { currentUser } = useAuth();
  const { tasks = [], projects = [], users = [], departments = [], teams = [], weeklyPlans = [], dailyPlans = [],
          meetings = [], notifications = [], updateMeeting, updateNotification } = useData();
  const navigate = useNavigate();

  const [selectedDataType, setSelectedDataType] = useState('tasks'); // 'tasks', 'projects', 'sop'
  const [timeFilter, setTimeFilter] = useState('month'); // 'week', 'month', 'quarter', 'year'
  const [selectedDepartment, setSelectedDepartment] = useState('all'); // 'all' or specific department ID
  const [selectedTeam, setSelectedTeam] = useState('all'); // 'all' or specific team ID
  const [selectedUser, setSelectedUser] = useState('all'); // 'all' or specific user ID
  const [expandedSections, setExpandedSections] = useState({
    departments: false,
    teams: false,
    users: false
  });
  const [selectedPriorityCategory, setSelectedPriorityCategory] = useState(null); // 'urgent-important', 'important-not-urgent', 'urgent-not-important', 'neither'
  const [viewMode, setViewMode] = useState('overview'); // 'overview', 'department', 'team'
  const [showDailyPlanner, setShowDailyPlanner] = useState(false);
  
  const [editPlanData, setEditPlanData] = useState(null);
  const [currentWeekStart, setCurrentWeekStart] = useState(getWeekStart(new Date()));
  const [planningType, setPlanningType] = useState('daily');
const [isAddingToExisting, setIsAddingToExisting] = useState(false);
// הוסף את ה-states החדשים כאן
  const [isEditingCalendar, setIsEditingCalendar] = useState(false);
const [weeklyScheduleState, setWeeklyScheduleState] = useState({});
const [draggedTask, setDraggedTask] = useState(null);
const [taskCompletionStatus, setTaskCompletionStatus] = useState({});
const [editSchedule, setEditSchedule] = useState({}); // State לעריכת הלוח
const [showWeeklyTaskSelector, setShowWeeklyTaskSelector] = useState(false); // State להצגת בחירת משימות שבועי
const [dailyFilterDepartment, setDailyFilterDepartment] = useState(''); // פילטר מחלקה ללוח יומי
const [dailyFilterProject, setDailyFilterProject] = useState(''); // פילטר פרויקט ללוח יומי
const [dailyFilterMyTasks, setDailyFilterMyTasks] = useState(true); // פילטר המשימות שלי ללוח יומי
const [weeklyFilterDepartment, setWeeklyFilterDepartment] = useState(''); // פילטר מחלקה ללוח שבועי
const [weeklyFilterProject, setWeeklyFilterProject] = useState(''); // פילטר פרויקט ללוח שבועי
const [weeklyFilterMyTasks, setWeeklyFilterMyTasks] = useState(true); // פילטר המשימות שלי ללוח שבועי
const [dailyRoutines, setDailyRoutines] = useState([]); // שגרות יומיות

// איפוס state כשמשנים שבוע
useEffect(() => {
  setWeeklyScheduleState({});
}, [currentWeekStart]);

// טעינת שגרות יומיות
useEffect(() => {
  const loadDailyRoutines = async () => {
    if (!currentUser) return;
    
    try {
      const routinesRef = collection(db, COLLECTIONS.DAILY_ROUTINES || 'dailyRoutines');
      const snapshot = await getDocs(routinesRef);
      const allRoutines = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      // סינון שגרות רלוונטיות למשתמש הנוכחי
      const filteredRoutines = allRoutines.filter(routine => {
        if (!routine.isActive) return false;
        
        // שגרות אישיות - רק של המשתמש
        if (routine.scope === 'personal') {
          return routine.createdBy === currentUser.id;
        }
        
        // שגרות ניהוליות
        if (routine.scope === 'managerial') {
          // שגרות לכל המחלקות
          if (routine.departmentId === 'all') {
            // אם יש משויכים ספציפיים - בדוק שהמשתמש ביניהם
            if (routine.assigneeIds && routine.assigneeIds.length > 0) {
              return routine.assigneeIds.includes(currentUser.id);
            }
            // אם אין משויכים ספציפיים - השגרה לכולם
            return true;
          }
          
          // שגרות למחלקה ספציפית
          if (routine.departmentId === currentUser.departmentId) {
            // אם יש משויכים ספציפיים - בדוק שהמשתמש ביניהם
            if (routine.assigneeIds && routine.assigneeIds.length > 0) {
              return routine.assigneeIds.includes(currentUser.id);
            }
            // אם יש assigneeId בודד - בדוק אותו
            if (routine.assigneeId) {
              return routine.assigneeId === currentUser.id;
            }
            // אם אין משויכים ספציפיים - השגרה לכל המחלקה!
            return true;
          }
        }
        
        return false;
      });
      
      console.log('🔵 Total routines loaded:', allRoutines.length);
      console.log('🟢 Filtered routines for user:', filteredRoutines.length);
      console.log('👤 Current user department:', currentUser.departmentId);
      filteredRoutines.forEach(r => {
        console.log(`  ✅ Routine: ${r.name}, Dept: ${r.departmentId}, Frequency: ${r.frequency}, Time: ${r.dueTime}`);
      });
      
      setDailyRoutines(filteredRoutines);
    } catch (error) {
      console.error('Error loading daily routines:', error);
    }
  };
  
  loadDailyRoutines();
}, [currentUser]);

// פונקציה לבדיקה אם שגרה מתוזמנת ליום מסוים
const isRoutineScheduledForDate = (routine, date) => {
  const checkDate = new Date(date);
  const dayOfWeek = checkDate.getDay();
  const dayOfMonth = checkDate.getDate();
  const month = checkDate.getMonth() + 1; // 1-12
  
  switch (routine.frequency || 'daily') {
    case 'daily':
      return true;
      
    case 'weekly':
      return dayOfWeek === (routine.weeklyDay || 1);
      
    case 'monthly':
      return dayOfMonth === (routine.monthlyDate || 1);
      
    case 'quarterly':
      const currentQuarter = Math.ceil(month / 3);
      const quarterStartMonth = (currentQuarter - 1) * 3 + 1;
      const targetMonth = quarterStartMonth + (routine.quarterlyMonth || 1) - 1;
      return month === targetMonth && dayOfMonth === (routine.quarterlyDay || 1);
      
    case 'yearly':
      return month === (routine.yearlyMonth || 1) && dayOfMonth === (routine.yearlyDay || 1);
      
    default:
      return true;
  }
};

// פתיחה אוטומטית של הטופס אם הגיע מפתיחת יום
useEffect(() => {
  if (openPlanner) {
    setShowDailyPlanner(true);
    setPlanningType('daily'); // או 'weekly' אם אתה מעדיף
  }
}, [openPlanner]);

  
  // State for notes
  const [ceoNotes, setCeoNotes] = useState('');
  
  // פונקציות לטיפול בישיבות מתוכננות
  const handleConfirmMeeting = async (notificationId, meetingId) => {
    try {
      const meeting = meetings.find(m => m.id === meetingId);
      if (!meeting) {
        alert('❌ לא נמצאה ישיבה זו');
        return;
      }

      // הוסף את המשתמש לרשימת המאושרים
      const confirmedParticipantIds = meeting.confirmedParticipantIds || [];
      if (!confirmedParticipantIds.includes(currentUser.id)) {
        confirmedParticipantIds.push(currentUser.id);
        await updateMeeting(meetingId, { confirmedParticipantIds });
      }

      // סמן את ההתראה כנקראה
      if (notificationId && updateNotification) {
        await updateNotification(notificationId, { 
          isRead: true,
          actionRequired: false 
        });
      }

      alert('✅ הגעתך לישיבה אושרה! הישיבה תופיע בתכנון שלך');
    } catch (error) {
      console.error('Error confirming meeting:', error);
      alert('❌ שגיאה באישור הישיבה');
    }
  };

  const handleDeclineMeeting = async (notificationId, meetingId) => {
    try {
      const meeting = meetings.find(m => m.id === meetingId);
      if (!meeting) {
        alert('❌ לא נמצאה ישיבה זו');
        return;
      }

      // הסר את המשתמש מרשימת המשתתפים
      const participantIds = (meeting.participantIds || []).filter(id => id !== currentUser.id);
      await updateMeeting(meetingId, { participantIds });

      // סמן את ההתראה כנקראה
      if (notificationId && updateNotification) {
        await updateNotification(notificationId, { 
          isRead: true,
          actionRequired: false 
        });
      }

      alert('✅ הודעת למארגן שלא תוכל להגיע');
    } catch (error) {
      console.error('Error declining meeting:', error);
      alert('❌ שגיאה בדחיית הישיבה');
    }
  };
  
  // פונקציה לטעינת הלוח השבועי
const loadWeeklySchedule = (weekStart) => {
  const weekStartDate = new Date(weekStart);
  const day = weekStartDate.getDay();
  if (day !== 0) {
    weekStartDate.setDate(weekStartDate.getDate() - day);
  }
  const weekStartStr = weekStartDate.toISOString().split('T')[0];
  
  const savedPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
  const plan = savedPlans.find(p => 
    (p.userId === currentUser?.id || p.userName === currentUser?.name) &&
    p.summaryData?.weekStart === weekStartStr
  );
  
  setWeeklyScheduleState(plan?.summaryData?.schedule || {});
};

// טעינה ראשונית
useEffect(() => {
  loadWeeklySchedule(currentWeekStart);
}, []);
  // פונקציה לטיפול בפעולות מהירות
// פונקציה לטיפול בפעולות מהירות
const handleQuickAction = (action) => {
  switch(action) {
    case 'daily-planning':
      setShowDailyPlanner(true);
      break;
    case 'day-opening':
      navigate('/day-opening');
      break;
    case 'day-summary':
      navigate('/day-summary');
      break;
    case 'tasks':
      navigate('/tasks');
      break;
    case 'my-tasks':
      navigate('/tasks'); // עם פילטר למשימות שלי
      break;
    case 'projects':
      navigate('/projects');
      break;
    case 'my-projects':
      navigate('/projects'); // עם פילטר לפרויקטים שלי
      break;
    case 'daily-routines':
      navigate('/daily-routines');
      break;
    case 'team-availability':
      navigate('/team-availability');
      break;
    case 'departments':
      navigate('/departments');
      break;
    case 'my-department':
      // מנהל מחלקה - ישירות למחלקה שלו
      if (currentUser?.departmentId) {
        navigate(`/departments/${currentUser.departmentId}`);
      } else {
        navigate('/departments');
      }
      break;
    case 'teams':
      navigate('/teams');
      break;
    case 'my-teams':
      // מנהל מחלקה - רק הצוותים שלו
      navigate('/teams', { 
        state: { filterByDepartment: currentUser?.departmentId } 
      });
      break;
    case 'my-team':
      // מנהל צוות - ישירות לצוות שלו
      if (currentUser?.teamId) {
        navigate(`/teams/${currentUser.teamId}`);
      } else {
        navigate('/teams');
      }
      break;
    case 'team-summaries':
      navigate('/team-summaries');
      break;
    case 'templates':
      navigate('/templates');
      break;
    case 'resources':
      navigate('/resources');
      break;
    case 'manager-dashboard':
      navigate('/manager-dashboard');
      break;
    case 'admin':
      navigate('/admin');
      break;
    case 'user-dashboards':
      navigate('/user-dashboards');
      break;
    case 'notifications':
      navigate('/notifications');
      break;
    case 'suggestions':
      navigate('/suggestions');
      break;
    default:
      console.log('Unknown action:', action);
  }
};

  // Helper function to get week start date
  function getWeekStart(date) {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day;
    return new Date(d.setDate(diff));
  }

  // Helper function to get week dates
  function getWeekDates(weekStart) {
    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(weekStart);
      date.setDate(weekStart.getDate() + i);
      dates.push(date);
    }
    return dates;
  }

  // Helper function to safely convert date to string
  const safeGetDateString = (dateValue) => {
    if (!dateValue) return null;
    
    try {
      if (typeof dateValue === 'string') {
        if (dateValue.includes('T')) {
          return dateValue.split('T')[0];
        }
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) {
          return null;
        }
        return date.toISOString().split('T')[0];
      }
      if (dateValue instanceof Date) {
        if (isNaN(dateValue.getTime())) {
          return null;
        }
        return dateValue.toISOString().split('T')[0];
      }
      if (typeof dateValue === 'number') {
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) {
          return null;
        }
        return date.toISOString().split('T')[0];
      }
      return null;
    } catch (error) {
      return null;
    }
  };

  // Get current user's department and team names
  const getUserDepartment = () => {
    return departments.find(d => d.id === currentUser?.departmentId)?.name || 'לא משויך למחלקה';
  };

  const getUserTeam = () => {
    return teams.find(t => t.id === currentUser?.teamId)?.name || 'לא משויך לצוות';
  };

  // Helper functions with role-based filtering
  const getFilteredTasks = () => {
    let filteredTasks = tasks.filter(task => 
      task.scope !== 'personal' &&
      !task.isDailyRoutine &&
      !task.routineId &&
      task.createdFrom !== 'daily_routine'
    );

    // Filter by user role
    if (currentUser?.role === 'worker') {
      // Workers see only tasks assigned to them
      filteredTasks = filteredTasks.filter(task => 
        task.assigneeId === currentUser.id || 
        (Array.isArray(task.assigneeIds) && task.assigneeIds.includes(currentUser.id))
      );
    } else if (currentUser?.role === 'team_manager') {
      // Team managers see tasks from their team
      filteredTasks = filteredTasks.filter(task => 
        task.teamId === currentUser.teamId ||
        task.assigneeId === currentUser.id ||
        (Array.isArray(task.assigneeIds) && task.assigneeIds.includes(currentUser.id))
      );
    } else if (currentUser?.role === 'dept_manager') {
      // Department managers see tasks from their department
      filteredTasks = filteredTasks.filter(task => 
        task.departmentId === currentUser.departmentId ||
        task.assigneeId === currentUser.id ||
        (Array.isArray(task.assigneeIds) && task.assigneeIds.includes(currentUser.id))
      );
    }
    // org_admin sees everything (no additional filter)

    // Filter by department
    if (selectedDepartment !== 'all') {
      filteredTasks = filteredTasks.filter(task => task.departmentId === selectedDepartment);
    }

    // Filter by team
    if (selectedTeam !== 'all') {
      filteredTasks = filteredTasks.filter(task => task.teamId === selectedTeam);
    }

    return filteredTasks;
  };

  const getFilteredProjects = () => {
    let filteredProjects = projects.filter(project => 
      project.scope !== 'personal'
    );

    // Filter by user role
    if (currentUser?.role === 'worker') {
      // Workers see only projects they're part of
      filteredProjects = filteredProjects.filter(project => 
        project.memberIds?.includes(currentUser.id) ||
        project.ownerId === currentUser.id
      );
    } else if (currentUser?.role === 'team_manager') {
      // Team managers see projects from their team
      filteredProjects = filteredProjects.filter(project => 
        project.teamId === currentUser.teamId ||
        project.memberIds?.includes(currentUser.id) ||
        project.ownerId === currentUser.id
      );
    } else if (currentUser?.role === 'dept_manager') {
      // Department managers see projects from their department
      filteredProjects = filteredProjects.filter(project => 
        project.departmentId === currentUser.departmentId ||
        project.memberIds?.includes(currentUser.id) ||
        project.ownerId === currentUser.id
      );
    }
    // org_admin sees everything (no additional filter)

    // Filter by department
    if (selectedDepartment !== 'all') {
      filteredProjects = filteredProjects.filter(project => project.departmentId === selectedDepartment);
    }

    // Filter by team
    if (selectedTeam !== 'all') {
      filteredProjects = filteredProjects.filter(project => project.teamId === selectedTeam);
    }

    return filteredProjects;
  };

// Get user's weekly tasks - כולל משימות מתכנון שבועי
const getUserWeeklyTasks = () => {
  const weekDates = getWeekDates(currentWeekStart);
  const weeklyTasksList = [];
  
  // תחילה - טען משימות מתכנון שבועי שנשמר
  const weekStartStr = currentWeekStart.toISOString().split('T')[0];
  const savedWeeklyPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
  const currentUserPlan = savedWeeklyPlans.find(plan => 
    (plan.userId === currentUser?.id || plan.userName === currentUser?.name) &&
    plan.summaryData?.weekStart === weekStartStr
  );
  
  if (currentUserPlan && currentUserPlan.summaryData?.schedule) {
    Object.entries(currentUserPlan.summaryData.schedule).forEach(([dateStr, daySchedule]) => {
      const date = new Date(dateStr);
      const dayIndex = date.getDay();
      
      Object.entries(daySchedule || {}).forEach(([time, task]) => {
        if (task && task.title) {
          weeklyTasksList.push({
            ...task,
            id: task.id || `weekly-${Date.now()}-${Math.random()}`,
            title: task.title,
            scheduledTime: time,
            dayIndex,
            date: dateStr,
            fromWeeklyPlan: true,
            status: task.status || 'ממתין לעבודה'
          });
        }
      });
    });
  }
  
  // אחר כך - הוסף משימות רגילות
  weekDates.forEach((date, dayIndex) => {
    const dateStr = date.toISOString().split('T')[0];
    
    // Get tasks for this day
    const dayTasks = tasks.filter(task => {
      const isAssigned = task.assigneeId === currentUser?.id || 
                        (Array.isArray(task.assigneeIds) && task.assigneeIds.includes(currentUser?.id));
      
      if (!isAssigned) return false;
      
      const taskDate = safeGetDateString(task.dueDate || task.scheduledDate);
      return taskDate === dateStr;
    });

    // Get daily plan tasks for this day
    const dailyPlan = dailyPlans.find(plan => 
      plan.userId === currentUser?.id && 
      plan.date === dateStr
    );

    if (dailyPlan?.tasks) {
      dailyPlan.tasks.forEach(planTask => {
        weeklyTasksList.push({
          ...planTask,
          dayIndex,
          date: dateStr,
          fromDailyPlan: true
        });
      });
    }

    // Add regular tasks
    dayTasks.forEach(task => {
      weeklyTasksList.push({
        ...task,
        dayIndex,
        date: dateStr,
        fromDailyPlan: false
      });
    });
  });

  return weeklyTasksList;
};
const getTasksByDepartment = () => {
  const deptStats = {};
  
  // סינון מחלקות לפי הרשאות
  let filteredDepartments = departments;
  
  if (currentUser?.role === 'dept_manager' && currentUser?.departmentId) {
    // מנהל מחלקה רואה רק את המחלקה שלו
    filteredDepartments = departments.filter(dept => 
      dept.id === currentUser.departmentId
    );
  }
  
  filteredDepartments.forEach(dept => {
    const deptTasks = tasks.filter(task => 
      task.departmentId === dept.id && 
      task.scope !== 'personal' &&
      !task.isDailyRoutine &&
      !task.routineId &&
      task.createdFrom !== 'daily_routine'
    );
    
    deptStats[dept.id] = {
      name: dept.name,
      total: deptTasks.length,
      completed: deptTasks.filter(t => t.status === 'הושלם').length,
      pending: deptTasks.filter(t => t.status === 'ממתין לעבודה' || t.status === 'במסלול').length,
      overdue: deptTasks.filter(t => 
        t.dueDate && new Date(t.dueDate) < new Date() && t.status !== 'הושלם'
      ).length,
      tasks: deptTasks
    };
  });
  return deptStats;
};

const getTasksByTeam = () => {
  const teamStats = {};
  
  // סינון צוותים לפי הרשאות
  let filteredTeams = teams;
  
  if (currentUser?.role === 'dept_manager' && currentUser?.departmentId) {
    // מנהל מחלקה רואה רק צוותים במחלקה שלו
    filteredTeams = teams.filter(team => 
      team.departmentId === currentUser.departmentId
    );
  } else if (currentUser?.role === 'team_manager' && currentUser?.teamId) {
    // מנהל צוות רואה רק את הצוות שלו
    filteredTeams = teams.filter(team => 
      team.id === currentUser.teamId
    );
  }
  
  filteredTeams.forEach(team => {
    const teamTasks = tasks.filter(task => 
      task.teamId === team.id && 
      task.scope !== 'personal' &&
      !task.isDailyRoutine &&
      !task.routineId &&
      task.createdFrom !== 'daily_routine'
    );
    
    teamStats[team.id] = {
      name: team.name,
      department: departments.find(d => d.id === team.departmentId)?.name || 'ללא מחלקה',
      total: teamTasks.length,
      completed: teamTasks.filter(t => t.status === 'הושלם').length,
      pending: teamTasks.filter(t => t.status === 'ממתין לעבודה' || t.status === 'במסלול').length,
      overdue: teamTasks.filter(t => 
        t.dueDate && new Date(t.dueDate) < new Date() && t.status !== 'הושלם'
      ).length,
      tasks: teamTasks
    };
  });
  return teamStats;
};

const getProjectsByDepartment = () => {
  const deptStats = {};
  
  // סינון מחלקות לפי הרשאות
  let filteredDepartments = departments;
  
  if (currentUser?.role === 'dept_manager' && currentUser?.departmentId) {
    filteredDepartments = departments.filter(dept => 
      dept.id === currentUser.departmentId
    );
  }
  
  filteredDepartments.forEach(dept => {
    const deptProjects = projects.filter(project => 
      project.departmentId === dept.id && 
      project.scope !== 'personal'
    );
    
    deptStats[dept.id] = {
      name: dept.name,
      total: deptProjects.length,
      active: deptProjects.filter(p => p.status === 'במסלול').length,
      completed: deptProjects.filter(p => p.status === 'הושלם').length,
      onHold: deptProjects.filter(p => p.status === 'מושהה').length,
      projects: deptProjects
    };
  });
  return deptStats;
};

  const getOverallStats = () => {
    const filteredTasks = getFilteredTasks();
    const filteredProjects = getFilteredProjects();
    
    return {
      tasks: {
        total: filteredTasks.length,
        completed: filteredTasks.filter(t => t.status === 'הושלם').length,
        pending: filteredTasks.filter(t => t.status === 'ממתין לעבודה' || t.status === 'במסלול').length,
        overdue: filteredTasks.filter(t => 
          t.dueDate && new Date(t.dueDate) < new Date() && t.status !== 'הושלם'
        ).length
      },
      projects: {
        total: filteredProjects.length,
        active: filteredProjects.filter(p => p.status === 'במסלול').length,
        completed: filteredProjects.filter(p => p.status === 'הושלם').length,
        onHold: filteredProjects.filter(p => p.status === 'מושהה').length
      }
    };
  };

  const overallStats = getOverallStats();
  const deptTaskStats = getTasksByDepartment();
  const teamTaskStats = getTasksByTeam();
  const deptProjectStats = getProjectsByDepartment();

  const dataTypes = [
    { id: 'tasks', name: 'משימות', icon: CheckSquare, color: 'blue' },
    { id: 'projects', name: 'פרויקטים', icon: Target, color: 'green' },
    { id: 'sop', name: 'תהליכי SOP', icon: Activity, color: 'purple' }
  ];

  const timeFilters = [
    { id: 'week', name: 'שבוע' },
    { id: 'month', name: 'חודש' },
    { id: 'quarter', name: 'רבעון' },
    { id: 'year', name: 'שנה' }
  ];

  const getCompletionRate = (completed, total) => {
    return total > 0 ? Math.round((completed / total) * 100) : 0;
  };

  const getTrendIcon = (current, previous) => {
    if (current > previous) return <ArrowUp className="w-4 h-4 text-green-500" />;
    if (current < previous) return <ArrowDown className="w-4 h-4 text-red-500" />;
    return <Minus className="w-4 h-4 text-gray-500" />;
  };

  // Navigation functions
  const handleNavigateToTasks = () => {
    navigate('/tasks');
  };

  const handleNavigateToCompletedTasks = () => {
    navigate('/tasks?filterCompleted=true');
  };

  const handleNavigateToPendingTasks = () => {
    navigate('/tasks?filterStatus=במסלול');
  };

  const handleNavigateToOverdueTasks = () => {
    navigate('/tasks?filterOverdue=true');
  };

  const handleNavigateToProjects = () => {
    navigate('/projects');
  };

  const handleNavigateToActiveProjects = () => {
    navigate('/projects?status=active');
  };

  const handleNavigateToCompletedProjects = () => {
    navigate('/projects?status=completed');
  };

  const handleNavigateToDepartment = (departmentId) => {
    navigate(`/departments/${departmentId}`);
  };

  const handleNavigateToTeam = (teamId) => {
    navigate(`/teams/${teamId}`);
  };

  const handleNavigateToTask = (taskId) => {
    navigate(`/tasks/${taskId}`);
  };

  const handleNavigateToProject = (projectId) => {
    navigate(`/projects/${projectId}`);
  };

const handleAddTaskToWeekly = () => {
  // טען מחדש את הלוח השבועי העדכני ביותר
  const weekStartDate = new Date(currentWeekStart);
  const day = weekStartDate.getDay();
  if (day !== 0) {
    weekStartDate.setDate(weekStartDate.getDate() - day);
  }
  const weekStartStr = weekStartDate.toISOString().split('T')[0];
  
  const savedPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
  const existingPlan = savedPlans.find(p => 
    (p.userId === currentUser?.id || p.userName === currentUser?.name) &&
    p.summaryData?.weekStart === weekStartStr
  );
  
  if (existingPlan) {
    // טען את התכנון הקיים ל-state
    setWeeklyScheduleState(existingPlan.summaryData?.schedule || {});
    
    // הכן את הנתונים לדיאלוג
    setEditPlanData({
      ...existingPlan,
      mode: 'add_tasks',
      isAddingToExisting: true
    });
  }
  
  // פתח את הדיאלוג
  setShowDailyPlanner(true);
  setPlanningType('weekly');
  setIsAddingToExisting(true);
};
 const handleEditWeeklyPlan = () => {
  const existingPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
  const currentWeekPlan = existingPlans.find(plan => {
    const planWeekStart = new Date(plan.summaryData?.weekStart);
    const currentWeekStartDate = getWeekStart(new Date());
    return planWeekStart.toDateString() === currentWeekStartDate.toDateString();
  });
  
  if (currentWeekPlan) {
    setEditPlanData(currentWeekPlan);
    setShowDailyPlanner(true);
    setPlanningType('weekly');
  } else {
    alert('אין תכנון שבועי קיים לשבוע זה. צור תכנון חדש תחילה.');
  }
};

  // Additional functionality functions
  const handleDownloadReport = () => {
    try {
      // Create a comprehensive report data
      const reportData = {
        summary: {
          tasks: overallStats.tasks,
          projects: overallStats.projects,
          efficiency: overallStats.tasks.total > 0 ? Math.round((overallStats.tasks.completed / overallStats.tasks.total) * 100) : 0
        },
        departments: Object.values(deptTaskStats),
        teams: Object.values(teamTaskStats),
        recentActivity: getFilteredTasks()
          .filter(task => task.status === 'הושלם')
          .sort((a, b) => {
            const dateA = new Date(b.updatedAt || b.createdAt || 0);
            const dateB = new Date(a.updatedAt || a.createdAt || 0);
            return dateA - dateB;
          })
          .slice(0, 10),
        generatedAt: new Date().toLocaleString('he-IL'),
        generatedBy: currentUser?.name || 'מנהל',
        filters: {
          department: selectedDepartment === 'all' ? 'כל המחלקות' : departments.find(d => d.id === selectedDepartment)?.name,
          team: selectedTeam === 'all' ? 'כל הצוותים' : teams.find(t => t.id === selectedTeam)?.name,
          timeFilter: timeFilters.find(f => f.id === timeFilter)?.name
        }
      };
      
      // Create and download JSON file
      const dataStr = JSON.stringify(reportData, null, 2);
      const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
      const exportFileDefaultName = `managerial-report-${new Date().toISOString().split('T')[0]}.json`;
      
      const linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.style.display = 'none';
      document.body.appendChild(linkElement);
      linkElement.click();
      document.body.removeChild(linkElement);
      
      // Show success message
      alert('הדוח הורד בהצלחה!');
    } catch (error) {
      console.error('Error downloading report:', error);
      alert('שגיאה בהורדת הדוח. נסה שוב.');
    }
  };

  const handleRefreshData = () => {
    // Force refresh by updating a dummy state
    setTimeFilter(prev => prev === 'week' ? 'month' : 'week');
    setTimeout(() => setTimeFilter(prev => prev === 'week' ? 'month' : 'week'), 100);
  };

  const handleCreateSOP = () => {
    navigate('/templates'); // Navigate to templates page where SOPs are managed
  };

  // Handle saving notes
  const handleSaveCeoNotes = () => {
    // Here you would save to database
    console.log('Saving CEO notes:', ceoNotes);
    alert('הערות מנכ"ל נשמרו בהצלחה!');
  };

  // Get tasks by priority category
  const getTasksByPriorityCategory = (category) => {
    const filteredTasks = getFilteredTasks();
    
    switch (category) {
      case 'urgent-important':
        return filteredTasks.filter(task => 
          task.priority === 'high' && 
          task.dueDate && 
          new Date(task.dueDate) <= new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
        );
      case 'important-not-urgent':
        return filteredTasks.filter(task => 
          task.priority === 'high' && 
          (!task.dueDate || new Date(task.dueDate) > new Date(Date.now() + 7 * 24 * 60 * 60 * 1000))
        );
      case 'urgent-not-important':
        return filteredTasks.filter(task => 
          task.priority !== 'high' && 
          task.dueDate && 
          new Date(task.dueDate) <= new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
        );
      case 'neither':
        return filteredTasks.filter(task => 
          task.priority !== 'high' && 
          (!task.dueDate || new Date(task.dueDate) > new Date(Date.now() + 7 * 24 * 60 * 60 * 1000))
        );
      default:
        return [];
    }
  };

  const getPriorityCategoryName = (category) => {
    switch (category) {
      case 'urgent-important': return 'דחוף וחשוב';
      case 'important-not-urgent': return 'חשוב לא דחוף';
      case 'urgent-not-important': return 'דחוף לא חשוב';
      case 'neither': return 'לא דחוף לא חשוב';
      default: return '';
    }
  };

  // Check if user has permission for quick actions
  const hasPermissionFor = (action) => {
    const role = currentUser?.role;
    
    switch(action) {
      case 'admin':
        return role === 'org_admin';
      case 'departments':
        return role === 'org_admin' || role === 'dept_manager';
      case 'teams':
        return role === 'org_admin' || role === 'dept_manager' || role === 'team_manager';
      case 'tasks':
      case 'projects':
      case 'routines':
      case 'templates':
        return true; // Everyone can see these
      default:
        return false;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                {currentUser?.role === 'employee' || currentUser?.role === 'worker' 
                  ? 'הדאשבורד האישי שלי' 
                  : currentUser?.role === 'team_manager'
                  ? 'דאשבורד מנהל הצוות'
                  : currentUser?.role === 'dept_manager'
                  ? 'דאשבורד מנהל המחלקה'
                  : 'לוח בקרה מנהלי'}
              </h1>
              <p className="text-gray-600 mt-2 text-lg">
                {currentUser?.role === 'employee' || currentUser?.role === 'worker'
                  ? 'כל המידע שאתה צריך - משימות, פרויקטים, שגרות וישיבות 🎯'
                  : currentUser?.role === 'team_manager'
                  ? 'ניהול ופיקוח על הצוות שלך - ביצועים, משימות ופרויקטים 👥'
                  : currentUser?.role === 'dept_manager'
                  ? 'ניהול ופיקוח על המחלקה שלך - צוותים, עובדים וביצועים 🏢'
                  : 'ניתוחים וסטטיסטיקות מפורטות על כל הפעילות הארגונית ✨'}
              </p>
              <div className="mt-3 flex items-center gap-4 text-sm">
                <div className="px-3 py-1 bg-blue-100 text-blue-800 rounded-lg">
                {currentUser?.name} | {currentUser?.role === 'org_admin' || currentUser?.role === 'ceo' ? 'מנכ"ל' : 
                      currentUser?.role === 'dept_manager' ? 'מנהל מחלקה' :
                      currentUser?.role === 'team_manager' ? 'מנהל צוות' : 'עובד'}
                </div>
                <div className="px-3 py-1 bg-green-100 text-green-800 rounded-lg">
                  מחלקה: {getUserDepartment()}
                </div>
                <div className="px-3 py-1 bg-purple-100 text-purple-800 rounded-lg">
                  צוות: {getUserTeam()}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <button
                onClick={() => setShowDailyPlanner(true)}
                className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-2xl hover:from-blue-700 hover:to-purple-700 transition-all duration-300 font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center gap-3"
              >
                <Calendar className="w-6 h-6" />
            תכנון יומי/שבועי 
              </button>
              
              {/* Department Filter - Only for managers */}
              {(currentUser?.role === 'org_admin' || currentUser?.role === 'dept_manager') && (
                <select
                  value={selectedDepartment}
                  onChange={(e) => {
                    setSelectedDepartment(e.target.value);
                    setSelectedTeam('all'); // Reset team when department changes
                  }}
                  className="px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                >
                  <option value="all">כל המחלקות</option>
                  {departments.map(dept => (
                    <option key={dept.id} value={dept.id}>{dept.name}</option>
                  ))}
                </select>
              )}

              {/* Team Filter - Only for managers */}
              {(currentUser?.role === 'org_admin' || currentUser?.role === 'dept_manager' || currentUser?.role === 'team_manager') && (
                <select
                  value={selectedTeam}
                  onChange={(e) => setSelectedTeam(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                  disabled={selectedDepartment === 'all'}
                >
                  <option value="all">כל הצוותים</option>
                  {teams
                    .filter(team => selectedDepartment === 'all' || team.departmentId === selectedDepartment)
                    .map(team => (
                      <option key={team.id} value={team.id}>{team.name}</option>
                    ))}
                </select>
              )}

              {/* Time Filter */}
              <select
                value={timeFilter}
                onChange={(e) => setTimeFilter(e.target.value)}
                className="px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
              >
                {timeFilters.map(filter => (
                  <option key={filter.id} value={filter.id}>{filter.name}</option>
                ))}
              </select>
              
              <button 
                onClick={handleRefreshData}
                className="p-3 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105"
                title="רענן נתונים"
              >
                <RefreshCw className="w-5 h-5 text-gray-600" />
              </button>
            </div>
          </div>
        </div>

        {/* Notifications Widget - התראות חשובות בראש הדף */}
        {notifications.filter(n =>
          n.userId === currentUser?.id &&
          !n.isRead &&
          (n.type === 'meeting_scheduled' || n.type === 'meeting_reminder')
        ).length > 0 && (
          <div className="mb-6">
            <div className="bg-gradient-to-r from-purple-50 to-blue-50 border-2 border-purple-300 rounded-2xl shadow-xl overflow-hidden">
              <div className="p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-xl shadow-lg animate-pulse">
                    <Bell className="w-7 h-7 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                      🔔 יש לך {notifications.filter(n =>
                        n.userId === currentUser?.id &&
                        !n.isRead &&
                        (n.type === 'meeting_scheduled' || n.type === 'meeting_reminder')
                      ).length} התראות חדשות
                    </h3>
                    <p className="text-sm text-gray-600 mt-1">
                      הזמנות לישיבות ותזכורות שממתינות לתשומת ליבך
                    </p>
                  </div>
                  <button
                    onClick={() => navigate('/notifications')}
                    className="px-6 py-3 bg-white text-purple-600 rounded-xl hover:bg-purple-50 transition-all duration-200 font-bold shadow-lg hover:shadow-xl flex items-center gap-2"
                  >
                    <Eye className="w-5 h-5" />
                    צפה בהכל
                  </button>
                </div>

                <div className="space-y-3 max-h-[400px] overflow-y-auto pr-2">
                  {notifications
                    .filter(n =>
                      n.userId === currentUser?.id &&
                      !n.isRead &&
                      (n.type === 'meeting_scheduled' || n.type === 'meeting_reminder')
                    )
                    .slice(0, 3)
                    .map(notification => {
                      const meeting = meetings.find(m => m.id === notification.meetingId);
                      const isMeetingReminder = notification.type === 'meeting_reminder';

                      return (
                        <div key={notification.id} className="bg-white rounded-xl shadow-lg p-5 border-r-4 border-purple-500 hover:shadow-xl transition-all duration-200 hover:scale-[1.01]">
                          <div className="flex items-start justify-between gap-4">
                            <div className="flex-1">
                              <div className="flex items-center gap-3 mb-2">
                                <div className={`p-2 rounded-lg ${isMeetingReminder ? 'bg-orange-100' : 'bg-purple-100'}`}>
                                  {isMeetingReminder ? (
                                    <Bell className="w-5 h-5 text-orange-600" />
                                  ) : (
                                    <CalendarDays className="w-5 h-5 text-purple-600" />
                                  )}
                                </div>
                                <div>
                                  <h4 className="font-bold text-lg text-gray-900">
                                    {notification.title}
                                  </h4>
                                  {meeting && (
                                    <p className="text-sm text-gray-500">
                                      {new Date(meeting.startDate?.toDate ? meeting.startDate.toDate() : meeting.startDate).toLocaleDateString('he-IL', {
                                        weekday: 'long',
                                        day: 'numeric',
                                        month: 'long',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <p className="text-gray-700 mb-2 text-base">
                                {notification.message}
                              </p>
                              {meeting && (
                                <div className="flex items-center gap-4 text-sm text-gray-600">
                                  {meeting.location && (
                                    <span className="flex items-center gap-1">
                                      📍 {meeting.location}
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>

                            {notification.type === 'meeting_scheduled' && notification.actionRequired && (
                              <div className="flex flex-col gap-2">
                                <button
                                  onClick={() => handleConfirmMeeting(notification.id, notification.meetingId)}
                                  className="px-5 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg hover:from-green-700 hover:to-green-800 transition-all duration-200 flex items-center gap-2 font-bold shadow-lg hover:shadow-xl text-sm"
                                >
                                  <Check className="w-4 h-4" />
                                  אשר הגעה
                                </button>
                                <button
                                  onClick={() => handleDeclineMeeting(notification.id, notification.meetingId)}
                                  className="px-5 py-2 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-lg hover:from-red-700 hover:to-red-800 transition-all duration-200 flex items-center gap-2 font-bold shadow-lg hover:shadow-xl text-sm"
                                >
                                  <X className="w-4 h-4" />
                                  לא אוכל
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>

                {notifications.filter(n =>
                  n.userId === currentUser?.id &&
                  !n.isRead &&
                  (n.type === 'meeting_scheduled' || n.type === 'meeting_reminder')
                ).length > 3 && (
                  <div className="mt-4 text-center">
                    <button
                      onClick={() => navigate('/notifications')}
                      className="text-purple-600 hover:text-purple-800 font-bold text-sm hover:underline"
                    >
                      ועוד {notifications.filter(n =>
                        n.userId === currentUser?.id &&
                        !n.isRead &&
                        (n.type === 'meeting_scheduled' || n.type === 'meeting_reminder')
                      ).length - 3} התראות נוספות...
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Pending Meeting Invitations Widget - הזמנות לישיבות חדשות */}
        {(() => {
          const pendingInvitations = meetings.filter(meeting => {
            return meeting.status === 'scheduled' &&
              meeting.participantIds?.includes(currentUser?.id) &&
              (!meeting.confirmedParticipantIds || !meeting.confirmedParticipantIds.includes(currentUser?.id)) &&
              meeting.startDate;
          }).sort((a, b) => {
            const dateA = a.startDate?.toDate ? a.startDate.toDate() : new Date(a.startDate);
            const dateB = b.startDate?.toDate ? b.startDate.toDate() : new Date(b.startDate);
            return dateA - dateB;
          });

          if (pendingInvitations.length === 0) return null;

          return (
            <div className="mb-6">
              <div className="bg-gradient-to-r from-yellow-50 via-orange-50 to-red-50 border-2 border-orange-300 rounded-2xl shadow-xl overflow-hidden animate-pulse">
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-gradient-to-r from-orange-600 to-red-600 rounded-xl shadow-lg animate-bounce">
                      <Bell className="w-7 h-7 text-white" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900">
                        🔔 יש לך {pendingInvitations.length} הזמנה{pendingInvitations.length > 1 ? '' : ''} לישיבה חדשה!
                      </h3>
                      <p className="text-sm text-gray-600 mt-1">
                        אנא אשר או דחה את ההזמנות למטה
                      </p>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {pendingInvitations.map(meeting => {
                      const meetingDate = meeting.startDate?.toDate ? meeting.startDate.toDate() : new Date(meeting.startDate);
                      const meetingEndDate = meeting.endDate ? (meeting.endDate?.toDate ? meeting.endDate.toDate() : new Date(meeting.endDate)) : null;
                      const isToday = meetingDate.toDateString() === new Date().toDateString();
                      const isTomorrow = meetingDate.toDateString() === new Date(Date.now() + 86400000).toDateString();

                      return (
                        <div
                          key={meeting.id}
                          className="bg-white rounded-xl shadow-lg p-5 border-r-4 border-orange-500"
                        >
                          {/* Meeting Header */}
                          <div className="flex items-center justify-between mb-3">
                            <div className={`px-3 py-1 rounded-full text-xs font-bold ${
                              isToday ? 'bg-red-600 text-white animate-pulse' :
                              isTomorrow ? 'bg-orange-600 text-white' :
                              'bg-gray-600 text-white'
                            }`}>
                              {isToday ? '🔥 היום!' :
                               isTomorrow ? '⭐ מחר' :
                               meetingDate.toLocaleDateString('he-IL', { day: 'numeric', month: 'short' })}
                            </div>
                            <div className="text-xs text-gray-500 font-mono">
                              {meetingDate.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })}
                            </div>
                          </div>

                          {/* Meeting Title */}
                          <h4 className="font-bold text-lg text-gray-900 mb-2">
                            {meeting.subject}
                          </h4>

                          {/* Meeting Purpose */}
                          {meeting.purpose && (
                            <p className="text-sm text-gray-600 mb-3">
                              {meeting.purpose}
                            </p>
                          )}

                          {/* Meeting Details */}
                          <div className="space-y-2 mb-4">
                            {meeting.location && (
                              <div className="flex items-center gap-2 text-sm text-gray-700">
                                <Globe className="w-4 h-4 text-orange-600" />
                                <span>{meeting.location}</span>
                              </div>
                            )}

                            {meetingEndDate && (
                              <div className="flex items-center gap-2 text-sm text-gray-700">
                                <Clock className="w-4 h-4 text-orange-600" />
                                <span>
                                  {meetingDate.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })}
                                  {' - '}
                                  {meetingEndDate.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })}
                                </span>
                              </div>
                            )}

                            {meeting.participantIds && meeting.participantIds.length > 0 && (
                              <div className="flex items-center gap-2 text-sm text-gray-700">
                                <Users className="w-4 h-4 text-orange-600" />
                                <span>{meeting.participantIds.length} משתתפים מוזמנים</span>
                              </div>
                            )}
                          </div>

                          {/* Action Buttons */}
                          <div className="flex gap-2 pt-4 border-t border-gray-200">
                            <button
                              onClick={async () => {
                                try {
                                  // הוסף את המשתמש לרשימת המאושרים
                                  const confirmedParticipantIds = meeting.confirmedParticipantIds || [];
                                  if (!confirmedParticipantIds.includes(currentUser.id)) {
                                    confirmedParticipantIds.push(currentUser.id);
                                    await updateMeeting(meeting.id, { confirmedParticipantIds });
                                    alert('✅ אישרת השתתפות בישיבה! הישיבה נוספה ללוח השבועי שלך');
                                  }
                                } catch (error) {
                                  console.error('Error confirming meeting:', error);
                                  alert('❌ שגיאה באישור הישיבה');
                                }
                              }}
                              className="flex-1 px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-200 font-bold shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                            >
                              <Check className="w-4 h-4" />
                              אשר הגעה
                            </button>
                            <button
                              onClick={async () => {
                                if (!window.confirm('האם אתה בטוח שאתה רוצה לדחות את ההזמנה לישיבה?')) return;
                                
                                try {
                                  // הסר את המשתמש מרשימת המשתתפים
                                  const participantIds = (meeting.participantIds || []).filter(id => id !== currentUser.id);
                                  await updateMeeting(meeting.id, { participantIds });
                                  alert('❌ דחית את ההזמנה לישיבה');
                                } catch (error) {
                                  console.error('Error declining meeting:', error);
                                  alert('❌ שגיאה בדחיית הישיבה');
                                }
                              }}
                              className="flex-1 px-4 py-2 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-lg hover:from-red-700 hover:to-red-800 transition-all duration-200 font-bold shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                            >
                              <X className="w-4 h-4" />
                              לא אוכל
                            </button>
                          </div>

                          {/* View Details Button */}
                          <button
                            onClick={() => navigate(`/meetings/${meeting.id}`)}
                            className="w-full mt-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-all duration-200 font-medium flex items-center justify-center gap-2"
                          >
                            <Eye className="w-4 h-4" />
                            צפה בפרטים המלאים
                          </button>
                        </div>
                      );
                    })}
                  </div>

                  <div className="mt-4 p-4 bg-orange-100 rounded-lg border border-orange-200">
                    <p className="text-sm text-orange-800">
                      ⚡ <strong>חשוב:</strong> לאחר שתאשר את ההזמנה, הישיבה תתווסף אוטומטית ללוח השבועי והיומי שלך ותחסום את השעות הרלוונטיות
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })()}

        {/* My Scheduled Meetings Widget - הישיבות המתוכננות שלי */}
        {(() => {
          console.log('=== DEBUG MY MEETINGS ===');
          console.log('Total meetings:', meetings.length);
          console.log('Current user ID:', currentUser?.id);
          
          // בדיקה מפורטת של כל ישיבה
          meetings.forEach((meeting, index) => {
            console.log(`\nMeeting #${index + 1}:`, {
              id: meeting.id,
              subject: meeting.subject,
              status: meeting.status,
              participantIds: meeting.participantIds,
              confirmedParticipantIds: meeting.confirmedParticipantIds,
              createdBy: meeting.createdBy,
              startDate: meeting.startDate,
              'Has confirmed IDs?': !!meeting.confirmedParticipantIds,
              'Confirmed IDs length': meeting.confirmedParticipantIds?.length || 0,
              'Includes me?': meeting.confirmedParticipantIds?.includes(currentUser?.id)
            });
          });

          const myScheduledMeetings = meetings.filter(meeting => {
            const isScheduled = meeting.status === 'scheduled';
            const hasConfirmedIds = meeting.confirmedParticipantIds && Array.isArray(meeting.confirmedParticipantIds);
            const includesMe = hasConfirmedIds && meeting.confirmedParticipantIds.includes(currentUser?.id);
            const hasStartDate = !!meeting.startDate;
            
            console.log(`\nFiltering "${meeting.subject}":`, {
              isScheduled,
              hasConfirmedIds,
              includesMe,
              hasStartDate,
              'PASS?': isScheduled && hasConfirmedIds && includesMe && hasStartDate
            });

            return isScheduled && hasConfirmedIds && includesMe && hasStartDate;
          }).sort((a, b) => {
            const dateA = a.startDate?.toDate ? a.startDate.toDate() : new Date(a.startDate);
            const dateB = b.startDate?.toDate ? b.startDate.toDate() : new Date(b.startDate);
            return dateA - dateB;
          });

          console.log('\n✅ My scheduled meetings count:', myScheduledMeetings.length);
          console.log('========================\n');

          return (
            <div className="mb-6">
              <div className="bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 rounded-2xl shadow-xl border-2 border-indigo-200 overflow-hidden">
                <div className="p-6">
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-3">
                      <div className="p-3 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl shadow-lg">
                        <CalendarDays className="w-7 h-7 text-white" />
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-gray-900">
                          📅 הישיבות המתוכננות שלי
                        </h3>
                        <p className="text-sm text-gray-600 mt-1">
                          {myScheduledMeetings.length === 0 
                            ? 'כאן תראה את הישיבות שאישרת השתתפות בהן' 
                            : `יש לך ${myScheduledMeetings.length} ישיבות מתוכננות שאישרת הגעה אליהן`
                          }
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => navigate('/meetings')}
                      className="px-6 py-3 bg-white text-indigo-600 rounded-xl hover:bg-indigo-50 transition-all duration-200 font-bold shadow-lg hover:shadow-xl flex items-center gap-2"
                    >
                      <Eye className="w-5 h-5" />
                      כל הישיבות
                    </button>
                  </div>

                  {myScheduledMeetings.length === 0 ? (
                    <div className="text-center py-12">
                      <div className="mx-auto w-24 h-24 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
                        <CalendarDays className="w-12 h-12 text-indigo-600" />
                      </div>
                      <h4 className="text-xl font-bold text-gray-700 mb-2">
                        אין לך ישיבות מתוכננות כרגע
                      </h4>
                      <p className="text-gray-600 mb-6">
                        כשתאשר הגעה לישיבה, היא תופיע כאן ותתווסף ללוח השבועי שלך
                      </p>
                      <button
                        onClick={() => navigate('/meetings')}
                        className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 font-bold shadow-lg hover:shadow-xl inline-flex items-center gap-2"
                      >
                        <Plus className="w-5 h-5" />
                        עבור לעמוד הישיבות
                      </button>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {myScheduledMeetings.slice(0, 6).map(meeting => {
                        const meetingDate = meeting.startDate?.toDate ? meeting.startDate.toDate() : new Date(meeting.startDate);
                        const meetingEndDate = meeting.endDate ? (meeting.endDate?.toDate ? meeting.endDate.toDate() : new Date(meeting.endDate)) : null;
                        const isToday = meetingDate.toDateString() === new Date().toDateString();
                        const isTomorrow = meetingDate.toDateString() === new Date(Date.now() + 86400000).toDateString();
                        const isPast = meetingDate < new Date();

                        return (
                          <div
                            key={meeting.id}
                            onClick={() => navigate(`/meetings/${meeting.id}`)}
                            className={`bg-white rounded-xl shadow-lg p-5 border-r-4 cursor-pointer hover:shadow-2xl transition-all duration-200 hover:scale-[1.02] ${
                              isToday ? 'border-green-500 bg-green-50' :
                              isTomorrow ? 'border-yellow-500 bg-yellow-50' :
                              isPast ? 'border-gray-400 bg-gray-50 opacity-60' :
                              'border-indigo-500'
                            }`}
                          >
                            {/* Date Badge */}
                            <div className="flex items-center justify-between mb-3">
                              <div className={`px-3 py-1 rounded-full text-xs font-bold ${
                                isToday ? 'bg-green-600 text-white' :
                                isTomorrow ? 'bg-yellow-600 text-white' :
                                isPast ? 'bg-gray-500 text-white' :
                                'bg-indigo-600 text-white'
                              }`}>
                                {isToday ? '🔥 היום' :
                                 isTomorrow ? '⭐ מחר' :
                                 isPast ? '✓ עבר' :
                                 meetingDate.toLocaleDateString('he-IL', { day: 'numeric', month: 'short' })}
                              </div>
                              <div className="text-xs text-gray-500 font-mono">
                                {meetingDate.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })}
                              </div>
                            </div>

                            {/* Meeting Title */}
                            <h4 className="font-bold text-lg text-gray-900 mb-2 line-clamp-2">
                              {meeting.subject}
                            </h4>

                            {/* Meeting Purpose */}
                            {meeting.purpose && (
                              <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                                {meeting.purpose}
                              </p>
                            )}

                            {/* Meeting Details */}
                            <div className="space-y-2">
                              {meeting.location && (
                                <div className="flex items-center gap-2 text-sm text-gray-700">
                                  <Globe className="w-4 h-4 text-indigo-600" />
                                  <span className="truncate">{meeting.location}</span>
                                </div>
                              )}

                              {meetingEndDate && (
                                <div className="flex items-center gap-2 text-sm text-gray-700">
                                  <Clock className="w-4 h-4 text-indigo-600" />
                                  <span>
                                    {meetingDate.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })}
                                    {' - '}
                                    {meetingEndDate.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })}
                                  </span>
                                </div>
                              )}

                              {meeting.participantIds && meeting.participantIds.length > 0 && (
                                <div className="flex items-center gap-2 text-sm text-gray-700">
                                  <Users className="w-4 h-4 text-indigo-600" />
                                  <span>{meeting.participantIds.length} משתתפים</span>
                                  {meeting.confirmedParticipantIds && (
                                    <span className="text-green-600 font-bold">
                                      ({meeting.confirmedParticipantIds.length} אישרו)
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>

                            {/* Confirmed Badge */}
                            <div className="mt-4 pt-3 border-t border-gray-200">
                              <div className="flex items-center justify-between">
                                <span className="text-xs text-green-600 font-bold flex items-center gap-1">
                                  <CheckCircle className="w-4 h-4" />
                                  אישרת הגעה
                                </span>
                                {isToday && (
                                  <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded-full font-bold animate-pulse">
                                    ⏰ היום!
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {myScheduledMeetings.length > 6 && (
                    <div className="mt-6 text-center">
                      <button
                        onClick={() => navigate('/meetings')}
                        className="text-indigo-600 hover:text-indigo-800 font-bold text-sm hover:underline"
                      >
                        ועוד {myScheduledMeetings.length - 6} ישיבות נוספות...
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })()}

        {/* Today's Meetings Widget - ישיבות היום */}
        {(() => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const tomorrow = new Date(today);
          tomorrow.setDate(tomorrow.getDate() + 1);

          const todayMeetings = meetings.filter(meeting => {
            if (meeting.status !== 'scheduled') return false;
            if (!meeting.confirmedParticipantIds || !meeting.confirmedParticipantIds.includes(currentUser?.id)) return false;

            const meetingDate = meeting.startDate?.toDate ? meeting.startDate.toDate() : new Date(meeting.startDate);
            return meetingDate >= today && meetingDate < tomorrow;
          });

          return todayMeetings.length > 0 && (
            <div className="mb-8">
              <div className="bg-gradient-to-r from-orange-50 to-red-50 border-2 border-orange-300 rounded-2xl shadow-xl overflow-hidden">
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="p-3 bg-gradient-to-r from-orange-600 to-red-600 rounded-xl shadow-lg animate-bounce">
                      <CalendarDays className="w-7 h-7 text-white" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900">
                        🔥 ישיבות היום - תזכורת חשובה!
                      </h3>
                      <p className="text-sm text-gray-600 mt-1">
                        יש לך {todayMeetings.length} ישיבות מתוכננות להיום
                      </p>
                    </div>
                  </div>

                  <div className="space-y-3">
                    {todayMeetings.map(meeting => (
                      <div key={meeting.id} className="bg-white rounded-xl shadow-lg p-5 border-r-4 border-orange-500">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-4">
                            <div className="p-3 bg-orange-100 rounded-lg">
                              <Clock className="w-8 h-8 text-orange-600" />
                            </div>
                            <div>
                              <h4 className="font-bold text-xl text-gray-900">{meeting.subject}</h4>
                              <p className="text-gray-600">{meeting.purpose}</p>
                              <div className="flex items-center gap-4 mt-2 text-sm">
                                <span className="font-bold text-orange-600 text-lg">
                                  ⏰ {meeting.startDate?.toDate ? 
                                    meeting.startDate.toDate().toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' }) :
                                    new Date(meeting.startDate).toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })
                                  } - {' '}
                                  {meeting.endDate?.toDate ? 
                                    meeting.endDate.toDate().toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' }) :
                                    new Date(meeting.endDate).toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })
                                  }
                                </span>
                                {meeting.location && (
                                  <span className="text-gray-600">📍 {meeting.location}</span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="px-4 py-2 bg-orange-100 text-orange-800 rounded-lg font-bold">
                            היום!
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })()}

{/* Quick Actions Section */}
<div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-6 mb-8">
  <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
    <div className="p-2 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-xl text-white">
      <Zap className="w-5 h-5" />
    </div>
    פעולות מהירות
  </h3>
  
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
    {getQuickActionsByRole(currentUser?.role).map((action, index) => {
      const Icon = action.icon;
      
      // מערך צבעים לכפתורים
      const colors = [
        'from-blue-50 to-cyan-50 hover:from-blue-100 hover:to-cyan-100 border-blue-200 hover:border-blue-300',
        'from-purple-50 to-violet-50 hover:from-purple-100 hover:to-violet-100 border-purple-200 hover:border-purple-300',
        'from-green-50 to-emerald-50 hover:from-green-100 hover:to-emerald-100 border-green-200 hover:border-green-300',
        'from-orange-50 to-amber-50 hover:from-orange-100 hover:to-amber-100 border-orange-200 hover:border-orange-300',
        'from-red-50 to-pink-50 hover:from-red-100 hover:to-pink-100 border-red-200 hover:border-red-300',
        'from-indigo-50 to-blue-50 hover:from-indigo-100 hover:to-blue-100 border-indigo-200 hover:border-indigo-300',
        'from-teal-50 to-cyan-50 hover:from-teal-100 hover:to-cyan-100 border-teal-200 hover:border-teal-300',
        'from-yellow-50 to-amber-50 hover:from-yellow-100 hover:to-amber-100 border-yellow-200 hover:border-yellow-300',
        'from-gray-50 to-slate-50 hover:from-gray-100 hover:to-slate-100 border-gray-300 hover:border-gray-400'
      ];
      
      const iconColors = [
        'from-blue-500 to-cyan-500',
        'from-purple-500 to-violet-500',
        'from-green-500 to-emerald-500',
        'from-orange-500 to-amber-500',
        'from-red-500 to-pink-500',
        'from-indigo-500 to-blue-500',
        'from-teal-500 to-cyan-500',
        'from-yellow-500 to-amber-500',
        'from-gray-600 to-slate-600'
      ];
      
      const buttonColor = colors[index % colors.length];
      const iconColor = iconColors[index % iconColors.length];
      
      return (
        <button
          key={index}
          onClick={() => handleQuickAction(action.action)}
          className={`bg-gradient-to-br ${buttonColor} rounded-2xl p-4 border transition-all duration-300 hover:scale-105 hover:shadow-lg group`}
        >
          <div className="text-center">
            <div className={`w-12 h-12 bg-gradient-to-r ${iconColor} rounded-xl flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform`}>
              <Icon className="w-6 h-6 text-white" />
            </div>
            <h4 className="font-semibold text-gray-900 text-sm">{action.label}</h4>
          </div>
        </button>
      );
    })}
  </div>
</div>
        {/* Data Type Selector */}
        <div className="mb-8">
          <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-6">
            <div className="flex space-x-2 bg-gray-100/80 p-2 rounded-2xl backdrop-blur-sm">
              {dataTypes.map(dataType => {
                const Icon = dataType.icon;
                const isSelected = selectedDataType === dataType.id;
                
                return (
                  <button
                    key={dataType.id}
                    onClick={() => setSelectedDataType(dataType.id)}
                    className={`flex-1 py-4 px-6 rounded-xl text-sm font-semibold transition-all duration-300 flex items-center justify-center gap-3 ${
                      isSelected
                        ? `bg-gradient-to-r from-${dataType.color}-500 to-${dataType.color}-600 text-white shadow-lg scale-105`
                        : 'text-gray-600 hover:text-gray-900 hover:bg-white/50'
                    }`}
                  >
                    <Icon className="w-5 h-5" />
                    {dataType.name}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Hero Section with Large Daily Planning Button */}
        <div className="mb-8 text-center">
          <div className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 rounded-3xl p-8 text-white shadow-2xl">
            <h2 className="text-4xl font-bold mb-4">ברוכים הבאים ללוח הבקרה המנהלי</h2>
            <p className="text-xl mb-8 opacity-90">ניהול חכם של כל הפעילות הארגונית במקום אחד</p>
          <button
  onClick={() => setShowDailyPlanner(true)}
  className="px-12 py-6 bg-white text-blue-600 rounded-2xl hover:bg-gray-100 transition-all duration-300 font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center gap-4 mx-auto"
>
              <Calendar className="w-8 h-8" />
              התחל תכנון יומי/שבועי
            </button>
          </div>
        </div>

        {/* Overall Statistics */}
        <div className="mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {selectedDataType === 'tasks' && (
              <>
                <div 
                  className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 p-6 cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-105"
                  onClick={handleNavigateToTasks}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="p-3 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl text-white">
                      <CheckSquare className="w-6 h-6" />
                    </div>
                    <span className="text-2xl font-bold text-blue-600">{overallStats.tasks.total}</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">סה"כ משימות</h3>
                  <p className="text-sm text-gray-600">כל המשימות הניהוליות</p>
                </div>
                
                <div 
                  className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 p-6 cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-105"
                  onClick={handleNavigateToCompletedTasks}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="p-3 bg-gradient-to-r from-green-500 to-green-600 rounded-xl text-white">
                      <TrendingUp className="w-6 h-6" />
                    </div>
                    <span className="text-2xl font-bold text-green-600">{overallStats.tasks.completed}</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">הושלמו</h3>
                  <p className="text-sm text-gray-600">{getCompletionRate(overallStats.tasks.completed, overallStats.tasks.total)}% השלמה</p>
                </div>
                
                <div 
                  className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 p-6 cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-105"
                  onClick={handleNavigateToPendingTasks}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="p-3 bg-gradient-to-r from-orange-500 to-orange-600 rounded-xl text-white">
                      <Calendar className="w-6 h-6" />
                    </div>
                    <span className="text-2xl font-bold text-orange-600">{overallStats.tasks.pending}</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">בטיפול</h3>
                  <p className="text-sm text-gray-600">משימות פעילות</p>
                </div>
                
                <div 
                  className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 p-6 cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-105"
                  onClick={handleNavigateToOverdueTasks}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="p-3 bg-gradient-to-r from-red-500 to-red-600 rounded-xl text-white">
                      <ArrowDown className="w-6 h-6" />
                    </div>
                    <span className="text-2xl font-bold text-red-600">{overallStats.tasks.overdue}</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">באיחור</h3>
                  <p className="text-sm text-gray-600">דורש תשומת לב</p>
                </div>
              </>
            )}

            {selectedDataType === 'projects' && (
              <>
                <div 
                  className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 p-6 cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-105"
                  onClick={handleNavigateToProjects}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="p-3 bg-gradient-to-r from-green-500 to-green-600 rounded-xl text-white">
                      <Target className="w-6 h-6" />
                    </div>
                    <span className="text-2xl font-bold text-green-600">{overallStats.projects.total}</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">סה"כ פרויקטים</h3>
                  <p className="text-sm text-gray-600">כל הפרויקטים הניהוליים</p>
                </div>
                
                <div 
                  className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 p-6 cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-105"
                  onClick={handleNavigateToActiveProjects}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="p-3 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl text-white">
                      <Activity className="w-6 h-6" />
                    </div>
                    <span className="text-2xl font-bold text-blue-600">{overallStats.projects.active}</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">פעילים</h3>
                  <p className="text-sm text-gray-600">פרויקטים במסלול</p>
                </div>
                
                <div 
                  className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 p-6 cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-105"
                  onClick={handleNavigateToCompletedProjects}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="p-3 bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl text-white">
                      <CheckSquare className="w-6 h-6" />
                    </div>
                    <span className="text-2xl font-bold text-purple-600">{overallStats.projects.completed}</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">הושלמו</h3>
                  <p className="text-sm text-gray-600">{getCompletionRate(overallStats.projects.completed, overallStats.projects.total)}% השלמה</p>
                </div>
                
                <div className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-lg border border-white/20 p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className="p-3 bg-gradient-to-r from-orange-500 to-orange-600 rounded-xl text-white">
                      <Minus className="w-6 h-6" />
                    </div>
                    <span className="text-2xl font-bold text-orange-600">{overallStats.projects.onHold}</span>
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">מושהה</h3>
                  <p className="text-sm text-gray-600">דורש מעקב</p>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Selected Entity Analysis */}
        {(selectedDepartment !== 'all' || selectedTeam !== 'all') && (
          <div className="mb-8">
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="p-2 bg-gradient-to-r from-orange-500 to-red-500 rounded-xl text-white">
                  <Target className="w-5 h-5" />
                </div>
                ניתוח מפורט - {selectedTeam !== 'all' ? teams.find(t => t.id === selectedTeam)?.name : departments.find(d => d.id === selectedDepartment)?.name}
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {selectedDataType === 'tasks' && (
                  <>
                    <div className="text-center p-4 bg-blue-50 rounded-2xl">
                      <div className="text-2xl font-bold text-blue-600">{overallStats.tasks.total}</div>
                      <div className="text-sm text-gray-600">סה"כ משימות</div>
                    </div>
                    <div className="text-center p-4 bg-green-50 rounded-2xl">
                      <div className="text-2xl font-bold text-green-600">{overallStats.tasks.completed}</div>
                      <div className="text-sm text-gray-600">הושלמו</div>
                    </div>
                    <div className="text-center p-4 bg-orange-50 rounded-2xl">
                      <div className="text-2xl font-bold text-orange-600">{overallStats.tasks.pending}</div>
                      <div className="text-sm text-gray-600">בטיפול</div>
                    </div>
                    <div className="text-center p-4 bg-red-50 rounded-2xl">
                      <div className="text-2xl font-bold text-red-600">{overallStats.tasks.overdue}</div>
                      <div className="text-sm text-gray-600">באיחור</div>
                    </div>
                  </>
                )}
                
                {selectedDataType === 'projects' && (
                  <>
                    <div className="text-center p-4 bg-green-50 rounded-2xl">
                      <div className="text-2xl font-bold text-green-600">{overallStats.projects.total}</div>
                      <div className="text-sm text-gray-600">סה"כ פרויקטים</div>
                    </div>
                    <div className="text-center p-4 bg-blue-50 rounded-2xl">
                      <div className="text-2xl font-bold text-blue-600">{overallStats.projects.active}</div>
                      <div className="text-sm text-gray-600">פעילים</div>
                    </div>
                    <div className="text-center p-4 bg-purple-50 rounded-2xl">
                      <div className="text-2xl font-bold text-purple-600">{overallStats.projects.completed}</div>
                      <div className="text-sm text-gray-600">הושלמו</div>
                    </div>
                    <div className="text-center p-4 bg-orange-50 rounded-2xl">
                      <div className="text-2xl font-bold text-orange-600">{overallStats.projects.onHold}</div>
                      <div className="text-sm text-gray-600">מושהה</div>
                    </div>
                  </>
                )}
              </div>
              
              {/* Users Analysis */}
              <div className="mt-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">ניתוח משתמשים</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {(() => {
                    const filteredUsers = users.filter(user => {
                      if (selectedTeam !== 'all') {
                        return user.teamId === selectedTeam;
                      }
                      if (selectedDepartment !== 'all') {
                        return user.departmentId === selectedDepartment;
                      }
                      return true;
                    });
                    
                    const activeUsers = filteredUsers.filter(user => user.isActive);
                    const managers = filteredUsers.filter(user => 
                      user.role === 'dept_manager' || user.role === 'team_manager'
                    );
                    
                    return (
                      <>
                        <div className="text-center p-4 bg-gray-50 rounded-2xl">
                          <div className="text-xl font-bold text-gray-600">{filteredUsers.length}</div>
                          <div className="text-sm text-gray-600">סה"כ משתמשים</div>
                        </div>
                        <div className="text-center p-4 bg-green-50 rounded-2xl">
                          <div className="text-xl font-bold text-green-600">{activeUsers.length}</div>
                          <div className="text-sm text-gray-600">משתמשים פעילים</div>
                        </div>
                        <div className="text-center p-4 bg-blue-50 rounded-2xl">
                          <div className="text-xl font-bold text-blue-600">{managers.length}</div>
                          <div className="text-sm text-gray-600">מנהלים</div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>
        )}


        {/* Detailed Analysis - Only for managers */}
        {(currentUser?.role === 'org_admin' || currentUser?.role === 'dept_manager') && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Department Analysis */}
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl text-white">
                    <Building2 className="w-5 h-5" />
                  </div>
                  ניתוח לפי מחלקות
                </h3>
                <button 
                  onClick={handleDownloadReport}
                  className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
                  title="הורד דוח"
                >
                  <Download className="w-5 h-5 text-gray-600" />
                </button>
              </div>
              
              <div className="space-y-4">
                {Object.values(selectedDataType === 'tasks' ? deptTaskStats : deptProjectStats).map((dept, index) => {
                  const departmentId = departments.find(d => d.name === dept.name)?.id;
                  return (
                  <div 
                    key={index} 
                    className="p-4 bg-gray-50/80 rounded-2xl border border-gray-200/50 cursor-pointer hover:bg-gray-100/80 transition-all duration-200 hover:shadow-md"
                    onClick={() => departmentId && handleNavigateToDepartment(departmentId)}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <h4 className="font-semibold text-gray-900">{dept.name}</h4>
                      <span className="text-lg font-bold text-blue-600">{dept.total}</span>
                    </div>
                    
                    <div className="grid grid-cols-3 gap-4 text-sm">
                      <div className="text-center">
                        <div className="text-green-600 font-semibold">{dept.completed || dept.active}</div>
                        <div className="text-gray-600">{selectedDataType === 'tasks' ? 'הושלמו' : 'פעילים'}</div>
                      </div>
                      <div className="text-center">
                        <div className="text-orange-600 font-semibold">{dept.pending || dept.onHold}</div>
                        <div className="text-gray-600">{selectedDataType === 'tasks' ? 'בטיפול' : 'מושהה'}</div>
                      </div>
                      <div className="text-center">
                        <div className="text-red-600 font-semibold">{dept.overdue || 0}</div>
                        <div className="text-gray-600">באיחור</div>
                      </div>
                    </div>
                    
                    <div className="mt-3">
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          className="bg-gradient-to-r from-blue-500 to-purple-500 h-2 rounded-full" 
                          style={{ 
                            width: `${getCompletionRate(
                              selectedDataType === 'tasks' ? dept.completed : dept.completed, 
                              dept.total
                            )}%` 
                          }}
                        ></div>
                      </div>
                      <div className="text-xs text-gray-500 mt-1 text-center">
                        {getCompletionRate(
                          selectedDataType === 'tasks' ? dept.completed : dept.completed, 
                          dept.total
                        )}% השלמה
                      </div>
                    </div>
                  </div>
                  );
                })}
              </div>
            </div>

            {/* Team Analysis */}
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl text-white">
                    <Users className="w-5 h-5" />
                  </div>
                  ניתוח לפי צוותים
                </h3>
                <button className="p-2 hover:bg-gray-100 rounded-xl transition-colors">
                  <BarChart3 className="w-5 h-5 text-gray-600" />
                </button>
              </div>
              
              <div className="space-y-4">
                {Object.values(teamTaskStats).map((team, index) => {
                  const teamId = teams.find(t => t.name === team.name)?.id;
                  return (
                  <div 
                    key={index} 
                    className="p-4 bg-gray-50/80 rounded-2xl border border-gray-200/50 cursor-pointer hover:bg-gray-100/80 transition-all duration-200 hover:shadow-md"
                    onClick={() => teamId && handleNavigateToTeam(teamId)}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <div>
                        <h4 className="font-semibold text-gray-900">{team.name}</h4>
                        <p className="text-sm text-gray-600">{team.department}</p>
                      </div>
                      <span className="text-lg font-bold text-green-600">{team.total}</span>
                    </div>
                    
                    <div className="grid grid-cols-3 gap-4 text-sm">
                      <div className="text-center">
                        <div className="text-green-600 font-semibold">{team.completed}</div>
                        <div className="text-gray-600">הושלמו</div>
                      </div>
                      <div className="text-center">
                        <div className="text-orange-600 font-semibold">{team.pending}</div>
                        <div className="text-gray-600">בטיפול</div>
                      </div>
                      <div className="text-center">
                        <div className="text-red-600 font-semibold">{team.overdue}</div>
                        <div className="text-gray-600">באיחור</div>
                      </div>
                    </div>
                    
                    <div className="mt-3">
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          className="bg-gradient-to-r from-green-500 to-emerald-500 h-2 rounded-full" 
                          style={{ width: `${getCompletionRate(team.completed, team.total)}%` }}
                        ></div>
                      </div>
                      <div className="text-xs text-gray-500 mt-1 text-center">
                        {getCompletionRate(team.completed, team.total)}% השלמה
                      </div>
                    </div>
                  </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {/* Role-based Dashboard Content */}
        <div className="mt-8">
          {currentUser?.role === 'employee' || currentUser?.role === 'worker' ? (
            /* Personal Statistics Widget for Employees */
            <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* My Tasks Stats */}
              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl shadow-xl border-2 border-blue-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl text-white">
                    <CheckSquare className="w-6 h-6" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">המשימות שלי</h3>
                </div>
                {(() => {
                  const myTasks = tasks.filter(t => 
                    (t.assigneeId === currentUser.id || t.assigneeIds?.includes(currentUser.id)) &&
                    !t.isDailyRoutine
                  );
                  const completed = myTasks.filter(t => t.status === 'הושלם').length;
                  const inProgress = myTasks.filter(t => t.status === 'במסלול' || t.status === 'בתהליך').length;
                  const pending = myTasks.filter(t => t.status === 'ממתין לעבודה').length;
                  
                  return (
                    <div className="space-y-4">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">✅ הושלמו</span>
                        <span className="text-2xl font-bold text-green-600">{completed}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">🔄 בתהליך</span>
                        <span className="text-2xl font-bold text-blue-600">{inProgress}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">⏳ ממתינות</span>
                        <span className="text-2xl font-bold text-gray-600">{pending}</span>
                      </div>
                      <div className="pt-4 border-t border-blue-200">
                        <div className="text-sm text-gray-600 mb-2">אחוז השלמה</div>
                        <div className="w-full bg-blue-200 rounded-full h-4">
                          <div 
                            className="bg-gradient-to-r from-blue-600 to-cyan-600 h-4 rounded-full transition-all duration-500"
                            style={{ width: `${myTasks.length > 0 ? (completed / myTasks.length * 100) : 0}%` }}
                          />
                        </div>
                        <div className="text-right text-sm font-bold text-blue-700 mt-1">
                          {myTasks.length > 0 ? Math.round(completed / myTasks.length * 100) : 0}%
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>

              {/* My Projects Stats */}
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl shadow-xl border-2 border-purple-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl text-white">
                    <FolderOpen className="w-6 h-6" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">הפרויקטים שלי</h3>
                </div>
                {(() => {
                  const myProjects = projects.filter(p => 
                    Array.isArray(p.teamMembers) && p.teamMembers.includes(currentUser.id)
                  );
                  const activeProjects = myProjects.filter(p => p.status !== 'completed').length;
                  const completedProjects = myProjects.filter(p => p.status === 'completed').length;
                  
                  return (
                    <div className="space-y-4">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">📁 סה"כ פרויקטים</span>
                        <span className="text-3xl font-bold text-purple-600">{myProjects.length}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">🚀 פעילים</span>
                        <span className="text-2xl font-bold text-blue-600">{activeProjects}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">✅ הושלמו</span>
                        <span className="text-2xl font-bold text-green-600">{completedProjects}</span>
                      </div>
                      {myProjects.length > 0 && (
                        <div className="pt-4 border-t border-purple-200">
                          <button
                            onClick={() => navigate('/projects')}
                            className="w-full py-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl hover:from-purple-700 hover:to-pink-700 transition-all font-bold"
                          >
                            צפה בכל הפרויקטים
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>

              {/* My Routines Today */}
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl shadow-xl border-2 border-green-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl text-white">
                    <RotateCcw className="w-6 h-6" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">השגרות שלי</h3>
                </div>
                {(() => {
                  // Filter routines assigned to current user
                  const myRoutines = dailyRoutines.filter(r => 
                    r.assigneeId === currentUser.id || r.assigneeIds?.includes(currentUser.id)
                  );
                  const todayRoutines = myRoutines.filter(r => 
                    isRoutineScheduledForDate(r, new Date())
                  );
                  
                  return (
                    <div className="space-y-4">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">📅 להיום</span>
                        <span className="text-3xl font-bold text-green-600">{todayRoutines.length}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">🔄 סה"כ שגרות</span>
                        <span className="text-2xl font-bold text-gray-700">{myRoutines.length}</span>
                      </div>
                      {todayRoutines.length > 0 && (
                        <div className="pt-4 border-t border-green-200">
                          <div className="text-sm text-green-700 font-medium mb-2">שגרות להיום:</div>
                          <div className="space-y-2 max-h-32 overflow-y-auto">
                            {todayRoutines.map(routine => (
                              <div key={routine.id} className="flex items-center gap-2 text-sm bg-white p-2 rounded-lg">
                                <RotateCcw className="w-4 h-4 text-green-600" />
                                <span className="truncate">{routine.name}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      <button
                        onClick={() => navigate('/daily-routines')}
                        className="w-full py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl hover:from-green-700 hover:to-emerald-700 transition-all font-bold mt-4"
                      >
                        נהל שגרות
                      </button>
                    </div>
                  );
                })()}
              </div>
            </div>
            
            {/* Urgent Tasks Widget for Employees */}
            <div className="mt-6">
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-3xl shadow-xl border-2 border-red-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-red-500 to-orange-500 rounded-xl text-white">
                    <AlertTriangle className="w-6 h-6" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">משימות דחופות שלי</h3>
                </div>
                {(() => {
                  const myTasks = tasks.filter(t => 
                    (t.assigneeId === currentUser.id || t.assigneeIds?.includes(currentUser.id)) &&
                    !t.isDailyRoutine &&
                    t.status !== 'הושלם'
                  );
                  
                  // משימות דחופות: priority high או due date קרוב
                  const urgentTasks = myTasks.filter(t => {
                    const isHighPriority = t.priority === 'high' || t.priority === 'urgent';
                    const isDueSoon = t.dueDate && new Date(t.dueDate) <= new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
                    const isOverdue = t.dueDate && new Date(t.dueDate) < new Date();
                    return isHighPriority || isDueSoon || isOverdue;
                  }).sort((a, b) => {
                    // Sort by due date (overdue first, then by date)
                    if (!a.dueDate) return 1;
                    if (!b.dueDate) return -1;
                    return new Date(a.dueDate) - new Date(b.dueDate);
                  });
                  
                  return (
                    <div className="space-y-3">
                      {urgentTasks.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                          <CheckCircle className="w-12 h-12 mx-auto mb-3 text-green-500" />
                          <p className="font-medium">כל הכבוד! 🎉</p>
                          <p className="text-sm">אין משימות דחופות כרגע</p>
                        </div>
                      ) : (
                        <>
                          <div className="flex items-center justify-between text-sm">
                            <span className="text-gray-600">נמצאו {urgentTasks.length} משימות דחופות</span>
                            <button
                              onClick={() => navigate('/tasks')}
                              className="text-red-600 hover:text-red-700 font-medium"
                            >
                              צפה בכל →
                            </button>
                          </div>
                          
                          <div className="space-y-2 max-h-64 overflow-y-auto">
                            {urgentTasks.slice(0, 5).map(task => {
                              const isOverdue = task.dueDate && new Date(task.dueDate) < new Date();
                              const daysUntilDue = task.dueDate 
                                ? Math.ceil((new Date(task.dueDate) - new Date()) / (1000 * 60 * 60 * 24))
                                : null;
                              
                              return (
                                <div 
                                  key={task.id}
                                  onClick={() => handleNavigateToTask(task.id)}
                                  className={`p-4 rounded-xl cursor-pointer transition-all hover:scale-102 hover:shadow-lg ${
                                    isOverdue 
                                      ? 'bg-red-100 border-2 border-red-400' 
                                      : 'bg-white border border-orange-300'
                                  }`}
                                >
                                  <div className="flex items-start justify-between gap-3">
                                    <div className="flex-1">
                                      <div className="font-bold text-gray-900 mb-1">{task.title}</div>
                                      <div className="text-sm text-gray-600 mb-2">{task.description}</div>
                                      <div className="flex items-center gap-3 text-xs">
                                        {task.dueDate && (
                                          <span className={`font-medium ${
                                            isOverdue 
                                              ? 'text-red-700' 
                                              : daysUntilDue <= 1 
                                              ? 'text-orange-700' 
                                              : 'text-gray-600'
                                          }`}>
                                            {isOverdue 
                                              ? `⚠️ באיחור ${Math.abs(daysUntilDue)} ימים`
                                              : daysUntilDue === 0
                                              ? '🔥 תאריך יעד: היום!'
                                              : daysUntilDue === 1
                                              ? '⏰ תאריך יעד: מחר'
                                              : `📅 נותרו ${daysUntilDue} ימים`
                                            }
                                          </span>
                                        )}
                                        {task.priority && (
                                          <span className="px-2 py-1 bg-red-200 text-red-800 rounded-full font-bold">
                                            {task.priority === 'high' || task.priority === 'urgent' ? '🔴 דחוף' : ''}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <ArrowLeft className="w-5 h-5 text-gray-400" />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          
                          {urgentTasks.length > 5 && (
                            <div className="text-center pt-2">
                              <button
                                onClick={() => navigate('/tasks')}
                                className="text-sm text-red-600 hover:text-red-700 font-medium"
                              >
                                +{urgentTasks.length - 5} משימות נוספות
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  );
                })()}
              </div>
            </div>
            </>
          ) : currentUser?.role === 'team_manager' ? (
            /* Team Manager Dashboard */
            <>
            {/* Team Overview Stats */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
              {/* Team Tasks Overview */}
              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl shadow-xl border-2 border-blue-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl text-white">
                    <CheckSquare className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">משימות הצוות</h3>
                </div>
                {(() => {
                  const teamUsers = users.filter(u => u.teamId === currentUser.teamId);
                  const teamTasks = tasks.filter(t => 
                    teamUsers.some(user => user.id === t.assigneeId || t.assigneeIds?.includes(user.id)) &&
                    !t.isDailyRoutine
                  );
                  const completed = teamTasks.filter(t => t.status === 'הושלם').length;
                  const inProgress = teamTasks.filter(t => t.status === 'במסלול' || t.status === 'בתהליך').length;
                  const pending = teamTasks.filter(t => t.status === 'ממתין לעבודה').length;
                  
                  return (
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">✅ הושלמו</span>
                        <span className="text-2xl font-bold text-green-600">{completed}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">🔄 בתהליך</span>
                        <span className="text-2xl font-bold text-blue-600">{inProgress}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">⏳ ממתינות</span>
                        <span className="text-2xl font-bold text-gray-600">{pending}</span>
                      </div>
                      <div className="pt-3 border-t border-blue-200">
                        <div className="text-sm text-gray-600 mb-2">אחוז השלמה</div>
                        <div className="w-full bg-blue-200 rounded-full h-3">
                          <div 
                            className="bg-gradient-to-r from-blue-600 to-cyan-600 h-3 rounded-full transition-all duration-500"
                            style={{ width: `${teamTasks.length > 0 ? (completed / teamTasks.length * 100) : 0}%` }}
                          />
                        </div>
                        <div className="text-right text-sm font-bold text-blue-700 mt-1">
                          {teamTasks.length > 0 ? Math.round(completed / teamTasks.length * 100) : 0}%
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>

              {/* Team Projects Overview */}
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl shadow-xl border-2 border-purple-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl text-white">
                    <FolderOpen className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">פרויקטים</h3>
                </div>
                {(() => {
                  const teamUsers = users.filter(u => u.teamId === currentUser.teamId);
                  const teamProjects = projects.filter(p => 
                    Array.isArray(p.teamMembers) && 
                    p.teamMembers.some(memberId => teamUsers.some(user => user.id === memberId))
                  );
                  const activeProjects = teamProjects.filter(p => p.status !== 'completed').length;
                  const completedProjects = teamProjects.filter(p => p.status === 'completed').length;
                  
                  return (
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">📁 סה"כ</span>
                        <span className="text-3xl font-bold text-purple-600">{teamProjects.length}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">🚀 פעילים</span>
                        <span className="text-2xl font-bold text-blue-600">{activeProjects}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">✅ הושלמו</span>
                        <span className="text-2xl font-bold text-green-600">{completedProjects}</span>
                      </div>
                    </div>
                  );
                })()}
              </div>

              {/* Team Members */}
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl shadow-xl border-2 border-green-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl text-white">
                    <Users className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">חברי הצוות</h3>
                </div>
                {(() => {
                  const teamUsers = users.filter(u => u.teamId === currentUser.teamId && u.isActive !== false);
                  
                  return (
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">👥 סה"כ</span>
                        <span className="text-3xl font-bold text-green-600">{teamUsers.length}</span>
                      </div>
                      <div className="pt-3 border-t border-green-200">
                        <div className="text-sm text-green-700 font-medium mb-2">חברי הצוות:</div>
                        <div className="space-y-2 max-h-32 overflow-y-auto">
                          {teamUsers.map(user => (
                            <div key={user.id} className="flex items-center gap-2 text-sm bg-white p-2 rounded-lg">
                              <div className="w-6 h-6 rounded-full bg-gradient-to-br from-green-500 to-emerald-500 flex items-center justify-center text-white font-bold text-xs">
                                {(user.name || 'U').charAt(0).toUpperCase()}
                              </div>
                              <span className="truncate">{user.name || user.email}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>

              {/* Team Efficiency */}
              <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-3xl shadow-xl border-2 border-orange-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-xl text-white">
                    <TrendingUp className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">יעילות הצוות</h3>
                </div>
                {(() => {
                  const teamUsers = users.filter(u => u.teamId === currentUser.teamId);
                  const teamTasks = tasks.filter(t => 
                    teamUsers.some(user => user.id === t.assigneeId || t.assigneeIds?.includes(user.id)) &&
                    !t.isDailyRoutine
                  );
                  const completed = teamTasks.filter(t => t.status === 'הושלם').length;
                  const efficiency = teamTasks.length > 0 ? Math.round((completed / teamTasks.length) * 100) : 0;
                  
                  return (
                    <div className="space-y-3">
                      <div className="text-center">
                        <div className="text-4xl font-bold text-orange-600 mb-2">{efficiency}%</div>
                        <div className="text-sm text-gray-600">יעילות כללית</div>
                      </div>
                      <div className="w-full bg-orange-200 rounded-full h-4">
                        <div 
                          className="bg-gradient-to-r from-orange-500 to-yellow-500 h-4 rounded-full transition-all duration-500"
                          style={{ width: `${efficiency}%` }}
                        />
                      </div>
                      <div className="text-center text-xs text-gray-600">
                        {completed} מתוך {teamTasks.length} משימות
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>

            {/* Team Members Detailed Performance */}
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl text-white">
                    <Users className="w-5 h-5" />
                  </div>
                  ביצועי חברי הצוות
                </h3>
                <button
                  onClick={() => navigate('/team-summaries')}
                  className="px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all font-bold"
                >
                  צפה בסיכומים
                </button>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {users.filter(u => u.teamId === currentUser.teamId && u.isActive !== false).map(user => {
                  const userTasks = tasks.filter(t => 
                    (t.assigneeId === user.id || t.assigneeIds?.includes(user.id)) &&
                    !t.isDailyRoutine
                  );
                  const completed = userTasks.filter(t => t.status === 'הושלם').length;
                  const inProgress = userTasks.filter(t => t.status === 'במסלול' || t.status === 'בתהליך').length;
                  const pending = userTasks.filter(t => t.status === 'ממתין לעבודה').length;
                  const efficiency = userTasks.length > 0 ? Math.round((completed / userTasks.length) * 100) : 0;
                  
                  return (
                    <div key={user.id} className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-6 border border-gray-200 hover:shadow-lg transition-all">
                      <div className="flex items-center gap-3 mb-4">
                        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center text-white font-bold text-lg">
                          {(user.name || 'U').charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <div className="font-bold text-gray-900">{user.name || user.email}</div>
                          <div className="text-sm text-gray-600">{user.role === 'employee' ? 'עובד' : user.role}</div>
                        </div>
                      </div>
                      
                      <div className="space-y-3">
                        <div className="flex items-center justify-between">
                          <span className="text-sm text-gray-600">יעילות</span>
                          <span className="text-lg font-bold text-blue-600">{efficiency}%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div 
                            className="bg-gradient-to-r from-blue-500 to-purple-500 h-2 rounded-full transition-all duration-500"
                            style={{ width: `${efficiency}%` }}
                          />
                        </div>
                        
                        <div className="grid grid-cols-3 gap-2 text-center text-xs">
                          <div className="bg-green-100 text-green-800 rounded-lg p-2">
                            <div className="font-bold">{completed}</div>
                            <div>הושלמו</div>
                          </div>
                          <div className="bg-blue-100 text-blue-800 rounded-lg p-2">
                            <div className="font-bold">{inProgress}</div>
                            <div>בתהליך</div>
                          </div>
                          <div className="bg-gray-100 text-gray-800 rounded-lg p-2">
                            <div className="font-bold">{pending}</div>
                            <div>ממתינות</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            </>
          ) : currentUser?.role === 'dept_manager' ? (
            /* Department Manager Dashboard */
            <>
            {/* Department Overview Stats */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
              {/* Department Tasks Overview */}
              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl shadow-xl border-2 border-blue-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl text-white">
                    <CheckSquare className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">משימות המחלקה</h3>
                </div>
                {(() => {
                  const deptTeams = teams.filter(t => t.departmentId === currentUser.departmentId);
                  const deptUsers = users.filter(u => deptTeams.some(team => team.id === u.teamId));
                  const deptTasks = tasks.filter(t => 
                    deptUsers.some(user => user.id === t.assigneeId || t.assigneeIds?.includes(user.id)) &&
                    !t.isDailyRoutine
                  );
                  const completed = deptTasks.filter(t => t.status === 'הושלם').length;
                  const inProgress = deptTasks.filter(t => t.status === 'במסלול' || t.status === 'בתהליך').length;
                  const pending = deptTasks.filter(t => t.status === 'ממתין לעבודה').length;
                  
                  return (
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">✅ הושלמו</span>
                        <span className="text-2xl font-bold text-green-600">{completed}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">🔄 בתהליך</span>
                        <span className="text-2xl font-bold text-blue-600">{inProgress}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">⏳ ממתינות</span>
                        <span className="text-2xl font-bold text-gray-600">{pending}</span>
                      </div>
                      <div className="pt-3 border-t border-blue-200">
                        <div className="text-sm text-gray-600 mb-2">אחוז השלמה</div>
                        <div className="w-full bg-blue-200 rounded-full h-3">
                          <div 
                            className="bg-gradient-to-r from-blue-600 to-cyan-600 h-3 rounded-full transition-all duration-500"
                            style={{ width: `${deptTasks.length > 0 ? (completed / deptTasks.length * 100) : 0}%` }}
                          />
                        </div>
                        <div className="text-right text-sm font-bold text-blue-700 mt-1">
                          {deptTasks.length > 0 ? Math.round(completed / deptTasks.length * 100) : 0}%
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>

              {/* Department Teams */}
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl shadow-xl border-2 border-purple-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl text-white">
                    <Users className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">צוותי המחלקה</h3>
                </div>
                {(() => {
                  const deptTeams = teams.filter(t => t.departmentId === currentUser.departmentId);
                  
                  return (
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">👥 סה"כ צוותים</span>
                        <span className="text-3xl font-bold text-purple-600">{deptTeams.length}</span>
                      </div>
                      <div className="pt-3 border-t border-purple-200">
                        <div className="text-sm text-purple-700 font-medium mb-2">צוותים:</div>
                        <div className="space-y-2 max-h-32 overflow-y-auto">
                          {deptTeams.map(team => (
                            <div key={team.id} className="flex items-center gap-2 text-sm bg-white p-2 rounded-lg">
                              <div className="w-6 h-6 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white font-bold text-xs">
                                {(team.name || 'T').charAt(0).toUpperCase()}
                              </div>
                              <span className="truncate">{team.name}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>

              {/* Department Members */}
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl shadow-xl border-2 border-green-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl text-white">
                    <User className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">עובדי המחלקה</h3>
                </div>
                {(() => {
                  const deptTeams = teams.filter(t => t.departmentId === currentUser.departmentId);
                  const deptUsers = users.filter(u => deptTeams.some(team => team.id === u.teamId) && u.isActive !== false);
                  
                  return (
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">👤 סה"כ עובדים</span>
                        <span className="text-3xl font-bold text-green-600">{deptUsers.length}</span>
                      </div>
                      <div className="pt-3 border-t border-green-200">
                        <div className="text-sm text-green-700 font-medium mb-2">עובדים:</div>
                        <div className="space-y-2 max-h-32 overflow-y-auto">
                          {deptUsers.slice(0, 5).map(user => (
                            <div key={user.id} className="flex items-center gap-2 text-sm bg-white p-2 rounded-lg">
                              <div className="w-6 h-6 rounded-full bg-gradient-to-br from-green-500 to-emerald-500 flex items-center justify-center text-white font-bold text-xs">
                                {(user.name || 'U').charAt(0).toUpperCase()}
                              </div>
                              <span className="truncate">{user.name || user.email}</span>
                            </div>
                          ))}
                          {deptUsers.length > 5 && (
                            <div className="text-xs text-gray-500 text-center">
                              +{deptUsers.length - 5} עובדים נוספים
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>

              {/* Department Efficiency */}
              <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-3xl shadow-xl border-2 border-orange-200 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-3 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-xl text-white">
                    <TrendingUp className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">יעילות המחלקה</h3>
                </div>
                {(() => {
                  const deptTeams = teams.filter(t => t.departmentId === currentUser.departmentId);
                  const deptUsers = users.filter(u => deptTeams.some(team => team.id === u.teamId));
                  const deptTasks = tasks.filter(t => 
                    deptUsers.some(user => user.id === t.assigneeId || t.assigneeIds?.includes(user.id)) &&
                    !t.isDailyRoutine
                  );
                  const completed = deptTasks.filter(t => t.status === 'הושלם').length;
                  const efficiency = deptTasks.length > 0 ? Math.round((completed / deptTasks.length) * 100) : 0;
                  
                  return (
                    <div className="space-y-3">
                      <div className="text-center">
                        <div className="text-4xl font-bold text-orange-600 mb-2">{efficiency}%</div>
                        <div className="text-sm text-gray-600">יעילות כללית</div>
                      </div>
                      <div className="w-full bg-orange-200 rounded-full h-4">
                        <div 
                          className="bg-gradient-to-r from-orange-500 to-yellow-500 h-4 rounded-full transition-all duration-500"
                          style={{ width: `${efficiency}%` }}
                        />
                      </div>
                      <div className="text-center text-xs text-gray-600">
                        {completed} מתוך {deptTasks.length} משימות
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>

            {/* Teams Performance */}
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl text-white">
                    <Users className="w-5 h-5" />
                  </div>
                  ביצועי צוותי המחלקה
                </h3>
                <button
                  onClick={() => navigate('/team-summaries')}
                  className="px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all font-bold"
                >
                  צפה בסיכומים
                </button>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {teams.filter(t => t.departmentId === currentUser.departmentId).map(team => {
                  const teamUsers = users.filter(u => u.teamId === team.id && u.isActive !== false);
                  const teamTasks = tasks.filter(t => 
                    teamUsers.some(user => user.id === t.assigneeId || t.assigneeIds?.includes(user.id)) &&
                    !t.isDailyRoutine
                  );
                  const completed = teamTasks.filter(t => t.status === 'הושלם').length;
                  const efficiency = teamTasks.length > 0 ? Math.round((completed / teamTasks.length) * 100) : 0;
                  
                  return (
                    <div key={team.id} className="bg-gradient-to-br from-gray-50 to-purple-50 rounded-2xl p-6 border border-gray-200 hover:shadow-lg transition-all">
                      <div className="flex items-center gap-3 mb-4">
                        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white font-bold text-lg">
                          {(team.name || 'T').charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <div className="font-bold text-gray-900">{team.name}</div>
                          <div className="text-sm text-gray-600">{teamUsers.length} עובדים</div>
                        </div>
                      </div>
                      
                      <div className="space-y-3">
                        <div className="flex items-center justify-between">
                          <span className="text-sm text-gray-600">יעילות</span>
                          <span className="text-lg font-bold text-purple-600">{efficiency}%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div 
                            className="bg-gradient-to-r from-purple-500 to-pink-500 h-2 rounded-full transition-all duration-500"
                            style={{ width: `${efficiency}%` }}
                          />
                        </div>
                        
                        <div className="grid grid-cols-2 gap-2 text-center text-xs">
                          <div className="bg-green-100 text-green-800 rounded-lg p-2">
                            <div className="font-bold">{completed}</div>
                            <div>הושלמו</div>
                          </div>
                          <div className="bg-blue-100 text-blue-800 rounded-lg p-2">
                            <div className="font-bold">{teamTasks.length}</div>
                            <div>סה"כ</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            </>
          ) : (
            /* CEO/Deputy CEO Dashboard with Selection Options */
            <>
            {/* Selection Controls - Tabs Style */}
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8 mb-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl text-white">
                    <Eye className="w-5 h-5" />
                  </div>
                  בחירת תצוגה
                </h3>
                <div className="text-sm text-gray-600">
                  בחר מה ברצונך לראות
                </div>
              </div>
              
              {/* Hierarchical Selection - Three Columns */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Department Column */}
                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 border-2 border-blue-200">
                  <button
                    onClick={() => setExpandedSections(prev => ({ ...prev, departments: !prev.departments }))}
                    className="w-full text-lg font-bold text-gray-800 mb-4 flex items-center justify-between gap-2 hover:bg-blue-100 p-2 rounded-lg transition-all"
                  >
                    <div className="flex items-center gap-2">
                      <Building2 className="w-5 h-5 text-blue-600" />
                      מחלקה
                    </div>
                    <div className={`transform transition-transform ${expandedSections.departments ? 'rotate-180' : ''}`}>
                      <ChevronDown className="w-5 h-5 text-blue-600" />
                    </div>
                  </button>
                  
                  {expandedSections.departments && (
                    <div className="space-y-2">
                      <button
                        onClick={() => {
                          setSelectedDepartment('all');
                          setSelectedTeam('all');
                          setSelectedUser('all');
                        }}
                        className={`w-full px-4 py-3 rounded-xl font-bold transition-all text-left ${
                          selectedDepartment === 'all'
                            ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                            : 'bg-white text-gray-700 hover:bg-blue-100 border border-blue-300'
                        }`}
                      >
                        🌐 כל המחלקות
                      </button>
                      {departments.map(dept => (
                        <button
                          key={dept.id}
                          onClick={() => {
                            setSelectedDepartment(dept.id);
                            setSelectedTeam('all');
                            setSelectedUser('all');
                          }}
                          className={`w-full px-4 py-3 rounded-xl font-bold transition-all text-left ${
                            selectedDepartment === dept.id
                              ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                              : 'bg-white text-gray-700 hover:bg-blue-100 border border-blue-300'
                          }`}
                        >
                          🏢 {dept.name}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {/* Team Column */}
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border-2 border-green-200">
                  <button
                    onClick={() => setExpandedSections(prev => ({ ...prev, teams: !prev.teams }))}
                    className="w-full text-lg font-bold text-gray-800 mb-4 flex items-center justify-between gap-2 hover:bg-green-100 p-2 rounded-lg transition-all"
                  >
                    <div className="flex items-center gap-2">
                      <Users className="w-5 h-5 text-green-600" />
                      צוות
                    </div>
                    <div className={`transform transition-transform ${expandedSections.teams ? 'rotate-180' : ''}`}>
                      <ChevronDown className="w-5 h-5 text-green-600" />
                    </div>
                  </button>
                  
                  {expandedSections.teams && (
                    <div className="space-y-2">
                      <button
                        onClick={() => {
                          setSelectedTeam('all');
                          setSelectedUser('all');
                        }}
                        className={`w-full px-4 py-3 rounded-xl font-bold transition-all text-left ${
                          selectedTeam === 'all'
                            ? 'bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg'
                            : 'bg-white text-gray-700 hover:bg-green-100 border border-green-300'
                        }`}
                      >
                        👥 כל הצוותים
                      </button>
                      {teams
                        .filter(team => selectedDepartment === 'all' || team.departmentId === selectedDepartment)
                        .map(team => (
                          <button
                            key={team.id}
                            onClick={() => {
                              setSelectedTeam(team.id);
                              setSelectedUser('all');
                            }}
                            className={`w-full px-4 py-3 rounded-xl font-bold transition-all text-left ${
                              selectedTeam === team.id
                                ? 'bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg'
                                : 'bg-white text-gray-700 hover:bg-green-100 border border-green-300'
                            }`}
                          >
                            👥 {team.name}
                          </button>
                        ))}
                    </div>
                  )}
                </div>

                {/* User Column */}
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 border-2 border-purple-200">
                  <button
                    onClick={() => setExpandedSections(prev => ({ ...prev, users: !prev.users }))}
                    className="w-full text-lg font-bold text-gray-800 mb-4 flex items-center justify-between gap-2 hover:bg-purple-100 p-2 rounded-lg transition-all"
                  >
                    <div className="flex items-center gap-2">
                      <User className="w-5 h-5 text-purple-600" />
                      עובד
                    </div>
                    <div className={`transform transition-transform ${expandedSections.users ? 'rotate-180' : ''}`}>
                      <ChevronDown className="w-5 h-5 text-purple-600" />
                    </div>
                  </button>
                  
                  {expandedSections.users && (
                    <div className="space-y-2">
                      <button
                        onClick={() => setSelectedUser('all')}
                        className={`w-full px-4 py-3 rounded-xl font-bold transition-all text-left ${
                          selectedUser === 'all'
                            ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg'
                            : 'bg-white text-gray-700 hover:bg-purple-100 border border-purple-300'
                        }`}
                      >
                        👤 כל העובדים
                      </button>
                      {users
                        .filter(user => {
                          if (selectedTeam === 'all') return true;
                          return user.teamId === selectedTeam;
                        })
                        .map(user => (
                          <button
                            key={user.id}
                            onClick={() => setSelectedUser(user.id)}
                            className={`w-full px-4 py-3 rounded-xl font-bold transition-all text-left ${
                              selectedUser === user.id
                                ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg'
                                : 'bg-white text-gray-700 hover:bg-purple-100 border border-purple-300'
                            }`}
                          >
                            👤 {user.name || user.email}
                          </button>
                        ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Dynamic Content Based on Selection */}
            {(() => {
              // Determine what to show based on selection
              let targetUsers = [];
              let targetName = '';
              let isSingleUser = false;
              
              if (selectedUser !== 'all') {
                targetUsers = [users.find(u => u.id === selectedUser)].filter(Boolean);
                targetName = targetUsers[0]?.name || targetUsers[0]?.email || 'עובד';
                isSingleUser = true;
              } else if (selectedTeam !== 'all') {
                targetUsers = users.filter(u => u.teamId === selectedTeam && u.isActive !== false);
                targetName = teams.find(t => t.id === selectedTeam)?.name || 'צוות';
              } else if (selectedDepartment !== 'all') {
                const deptTeams = teams.filter(t => t.departmentId === selectedDepartment);
                targetUsers = users.filter(u => deptTeams.some(team => team.id === u.teamId) && u.isActive !== false);
                targetName = departments.find(d => d.id === selectedDepartment)?.name || 'מחלקה';
              } else {
                targetUsers = users.filter(u => u.isActive !== false);
                targetName = 'כל הארגון';
              }

              const targetTasks = tasks.filter(t => 
                targetUsers.some(user => user.id === t.assigneeId || t.assigneeIds?.includes(user.id)) &&
                !t.isDailyRoutine
              );
              const completed = targetTasks.filter(t => t.status === 'הושלם').length;
              const inProgress = targetTasks.filter(t => t.status === 'במסלול' || t.status === 'בתהליך').length;
              const pending = targetTasks.filter(t => t.status === 'ממתין לעבודה').length;
              const efficiency = targetTasks.length > 0 ? Math.round((completed / targetTasks.length) * 100) : 0;

              // אם נבחר עובד יחיד, הצג תצוגה מפורטת
              if (isSingleUser && targetUsers.length > 0) {
                const user = targetUsers[0];
                const userTasks = tasks.filter(t => 
                  (t.assigneeId === user.id || t.assigneeIds?.includes(user.id)) &&
                  !t.isDailyRoutine
                );
                const userProjects = projects.filter(p => 
                  Array.isArray(p.teamMembers) && p.teamMembers.includes(user.id)
                );
                const userRoutines = dailyRoutines.filter(r => 
                  r.assigneeId === user.id || r.assigneeIds?.includes(user.id)
                );
                const todayRoutines = userRoutines.filter(r => 
                  isRoutineScheduledForDate(r, new Date())
                );
                
                // משימות דחופות של העובד
                const urgentTasks = userTasks.filter(t => {
                  const isHighPriority = t.priority === 'high' || t.priority === 'urgent';
                  const isDueSoon = t.dueDate && new Date(t.dueDate) <= new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
                  const isOverdue = t.dueDate && new Date(t.dueDate) < new Date();
                  return (isHighPriority || isDueSoon || isOverdue) && t.status !== 'הושלם';
                });

                return (
                  <>
                    {/* Employee Profile Header */}
                    <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl shadow-xl border-2 border-purple-200 p-8 mb-8">
                      <div className="flex items-center gap-6">
                        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white font-bold text-2xl">
                          {(user.name || 'U').charAt(0).toUpperCase()}
                        </div>
                        <div className="flex-1">
                          <h2 className="text-3xl font-bold text-gray-900 mb-2">{user.name || user.email}</h2>
                          <div className="flex items-center gap-4 text-sm">
                            <div className="px-3 py-1 bg-blue-100 text-blue-800 rounded-lg">
                              {user.role === 'employee' ? 'עובד' : user.role}
                            </div>
                            <div className="px-3 py-1 bg-green-100 text-green-800 rounded-lg">
                              מחלקה: {departments.find(d => d.id === user.departmentId)?.name || 'לא מוגדר'}
                            </div>
                            <div className="px-3 py-1 bg-purple-100 text-purple-800 rounded-lg">
                              צוות: {teams.find(t => t.id === user.teamId)?.name || 'לא מוגדר'}
                            </div>
                          </div>
                        </div>
                        <div className="text-right">
                          <div className="text-4xl font-bold text-purple-600">{efficiency}%</div>
                          <div className="text-sm text-gray-600">יעילות כללית</div>
                        </div>
                      </div>
                    </div>

                    {/* Employee Stats Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
                      {/* Tasks Stats */}
                      <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl shadow-xl border-2 border-blue-200 p-6">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="p-3 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl text-white">
                            <CheckSquare className="w-6 h-6" />
                          </div>
                          <h3 className="text-lg font-bold text-gray-900">משימות</h3>
                        </div>
                        <div className="space-y-3">
                          <div className="flex items-center justify-between">
                            <span className="text-gray-700">✅ הושלמו</span>
                            <span className="text-2xl font-bold text-green-600">{completed}</span>
                          </div>
                          <div className="flex items-center justify-between">
                            <span className="text-gray-700">🔄 בתהליך</span>
                            <span className="text-2xl font-bold text-blue-600">{inProgress}</span>
                          </div>
                          <div className="flex items-center justify-between">
                            <span className="text-gray-700">⏳ ממתינות</span>
                            <span className="text-2xl font-bold text-gray-600">{pending}</span>
                          </div>
                          <div className="pt-3 border-t border-blue-200">
                            <div className="text-sm text-gray-600 mb-2">אחוז השלמה</div>
                            <div className="w-full bg-blue-200 rounded-full h-3">
                              <div 
                                className="bg-gradient-to-r from-blue-600 to-cyan-600 h-3 rounded-full transition-all duration-500"
                                style={{ width: `${efficiency}%` }}
                              />
                            </div>
                            <div className="text-right text-sm font-bold text-blue-700 mt-1">
                              {efficiency}%
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Projects Stats */}
                      <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl shadow-xl border-2 border-green-200 p-6">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="p-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl text-white">
                            <FolderOpen className="w-6 h-6" />
                          </div>
                          <h3 className="text-lg font-bold text-gray-900">פרויקטים</h3>
                        </div>
                        <div className="space-y-3">
                          <div className="flex items-center justify-between">
                            <span className="text-gray-700">📁 סה"כ</span>
                            <span className="text-3xl font-bold text-green-600">{userProjects.length}</span>
                          </div>
                          <div className="flex items-center justify-between">
                            <span className="text-gray-700">🚀 פעילים</span>
                            <span className="text-2xl font-bold text-blue-600">{userProjects.filter(p => p.status !== 'completed').length}</span>
                          </div>
                          <div className="flex items-center justify-between">
                            <span className="text-gray-700">✅ הושלמו</span>
                            <span className="text-2xl font-bold text-purple-600">{userProjects.filter(p => p.status === 'completed').length}</span>
                          </div>
                        </div>
                      </div>

                      {/* Routines Stats */}
                      <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-3xl shadow-xl border-2 border-orange-200 p-6">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="p-3 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-xl text-white">
                            <RotateCcw className="w-6 h-6" />
                          </div>
                          <h3 className="text-lg font-bold text-gray-900">שגרות</h3>
                        </div>
                        <div className="space-y-3">
                          <div className="flex items-center justify-between">
                            <span className="text-gray-700">📅 להיום</span>
                            <span className="text-3xl font-bold text-orange-600">{todayRoutines.length}</span>
                          </div>
                          <div className="flex items-center justify-between">
                            <span className="text-gray-700">🔄 סה"כ</span>
                            <span className="text-2xl font-bold text-gray-700">{userRoutines.length}</span>
                          </div>
                        </div>
                      </div>

                      {/* Urgent Tasks */}
                      <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-3xl shadow-xl border-2 border-red-200 p-6">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="p-3 bg-gradient-to-r from-red-500 to-pink-500 rounded-xl text-white">
                            <AlertTriangle className="w-6 h-6" />
                          </div>
                          <h3 className="text-lg font-bold text-gray-900">דחופות</h3>
                        </div>
                        <div className="text-center">
                          <div className="text-4xl font-bold text-red-600 mb-2">{urgentTasks.length}</div>
                          <div className="text-sm text-gray-600">משימות דחופות</div>
                        </div>
                      </div>
                    </div>

                    {/* Urgent Tasks Detail */}
                    {urgentTasks.length > 0 && (
                      <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8 mb-8">
                        <div className="flex items-center justify-between mb-6">
                          <h3 className="text-xl font-bold text-gray-900 flex items-center gap-3">
                            <div className="p-2 bg-gradient-to-r from-red-500 to-pink-500 rounded-xl text-white">
                              <AlertTriangle className="w-5 h-5" />
                            </div>
                            משימות דחופות של {user.name}
                          </h3>
                        </div>
                        
                        <div className="space-y-4">
                          {urgentTasks.slice(0, 5).map(task => {
                            const isOverdue = task.dueDate && new Date(task.dueDate) < new Date();
                            const daysUntilDue = task.dueDate 
                              ? Math.ceil((new Date(task.dueDate) - new Date()) / (1000 * 60 * 60 * 24))
                              : null;
                            
                            return (
                              <div 
                                key={task.id}
                                onClick={() => handleNavigateToTask(task.id)}
                                className={`p-4 rounded-xl cursor-pointer transition-all hover:scale-102 hover:shadow-lg ${
                                  isOverdue 
                                    ? 'bg-red-100 border-2 border-red-400' 
                                    : 'bg-white border border-orange-300'
                                }`}
                              >
                                <div className="flex items-start justify-between gap-3">
                                  <div className="flex-1">
                                    <div className="font-bold text-gray-900 mb-1">{task.title}</div>
                                    <div className="text-sm text-gray-600 mb-2">{task.description}</div>
                                    <div className="flex items-center gap-3 text-xs">
                                      {task.dueDate && (
                                        <span className={`font-medium ${
                                          isOverdue 
                                            ? 'text-red-700' 
                                            : daysUntilDue <= 1 
                                            ? 'text-orange-700' 
                                            : 'text-gray-600'
                                        }`}>
                                          {isOverdue 
                                            ? `⚠️ באיחור ${Math.abs(daysUntilDue)} ימים`
                                            : daysUntilDue === 0
                                            ? '🔥 תאריך יעד: היום!'
                                            : daysUntilDue === 1
                                            ? '⏰ תאריך יעד: מחר'
                                            : `📅 נותרו ${daysUntilDue} ימים`
                                          }
                                        </span>
                                      )}
                                      {task.priority && (
                                        <span className="px-2 py-1 bg-red-200 text-red-800 rounded-full font-bold">
                                          {task.priority === 'high' || task.priority === 'urgent' ? '🔴 דחוף' : ''}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <ArrowLeft className="w-5 h-5 text-gray-400" />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </>
                );
              }

              // תצוגה רגילה למחלקה/צוות/כל הארגון
              return (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                  {/* Overview Stats */}
                  <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl shadow-xl border-2 border-blue-200 p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="p-3 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl text-white">
                        <CheckSquare className="w-6 h-6" />
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">משימות {targetName}</h3>
                    </div>
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">✅ הושלמו</span>
                        <span className="text-2xl font-bold text-green-600">{completed}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">🔄 בתהליך</span>
                        <span className="text-2xl font-bold text-blue-600">{inProgress}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">⏳ ממתינות</span>
                        <span className="text-2xl font-bold text-gray-600">{pending}</span>
                      </div>
                      <div className="pt-3 border-t border-blue-200">
                        <div className="text-sm text-gray-600 mb-2">אחוז השלמה</div>
                        <div className="w-full bg-blue-200 rounded-full h-3">
                          <div 
                            className="bg-gradient-to-r from-blue-600 to-cyan-600 h-3 rounded-full transition-all duration-500"
                            style={{ width: `${efficiency}%` }}
                          />
                        </div>
                        <div className="text-right text-sm font-bold text-blue-700 mt-1">
                          {efficiency}%
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* People Count */}
                  <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl shadow-xl border-2 border-purple-200 p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="p-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl text-white">
                        <Users className="w-6 h-6" />
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">אנשים</h3>
                    </div>
                    <div className="text-center">
                      <div className="text-4xl font-bold text-purple-600 mb-2">{targetUsers.length}</div>
                      <div className="text-sm text-gray-600">{targetName}</div>
                    </div>
                  </div>

                  {/* Efficiency */}
                  <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl shadow-xl border-2 border-green-200 p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="p-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl text-white">
                        <TrendingUp className="w-6 h-6" />
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">יעילות</h3>
                    </div>
                    <div className="text-center">
                      <div className="text-4xl font-bold text-green-600 mb-2">{efficiency}%</div>
                      <div className="text-sm text-gray-600">יעילות כללית</div>
                    </div>
                  </div>

                </div>
              );
            })()}
            </>
          )}
        </div>

        {/* Advanced Analytics Section - Only for Managers */}
        {!(currentUser?.role === 'employee' || currentUser?.role === 'worker') && (
        <div className="mt-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Timeline Chart */}
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl text-white">
                    <Clock className="w-5 h-5" />
                  </div>
                  ציר זמן משימות
                </h3>
                <button 
                  onClick={handleDownloadReport}
                  className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
                  title="הורד דוח ציר זמן"
                >
                  <Download className="w-5 h-5 text-gray-600" />
                </button>
              </div>
              
              {/* Real Timeline Chart */}
              <div className="min-h-48 bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-4">
                <div className="h-full flex items-center justify-between">
                  {(() => {
                    const last7Days = Array.from({ length: 7 }, (_, i) => {
                      const date = new Date();
                      date.setDate(date.getDate() - (6 - i));
                      return date.toISOString().split('T')[0];
                    });
                    
                    return last7Days.map((date, index) => {
                      const dayTasks = getFilteredTasks().filter(task => {
                        const taskDate = safeGetDateString(task.createdAt);
                        return taskDate === date;
                      });
                      const completedTasks = dayTasks.filter(task => task.status === 'הושלם');
                      const height = dayTasks.length > 0 ? (completedTasks.length / dayTasks.length) * 100 : 0;
                      
                      return (
                        <div key={index} className="flex flex-col items-center flex-1">
                          <div className="w-full bg-white rounded-t-lg shadow-sm relative" style={{ height: '80px' }}>
                            <div 
                              className="bg-gradient-to-t from-green-500 to-emerald-400 rounded-t-lg transition-all duration-1000 ease-out"
                              style={{ height: `${height}%` }}
                            ></div>
                          </div>
                          <div className="mt-2 text-center">
                            <div className="text-xs text-gray-600">
                              {new Date(date).toLocaleDateString('he-IL', { weekday: 'short' })}
                            </div>
                            <div className="text-xs text-gray-500">{dayTasks.length}</div>
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
              </div>
            </div>

            {/* Priority Matrix */}
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-orange-500 to-red-500 rounded-xl text-white">
                    <AlertTriangle className="w-5 h-5" />
                  </div>
                  מטריצת עדיפויות
                </h3>
                <button className="p-2 hover:bg-gray-100 rounded-xl transition-colors">
                  <Filter className="w-5 h-5 text-gray-600" />
                </button>
              </div>
              
              {/* Real Priority Matrix */}
              <div className="min-h-48 bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-4">
                <div className="grid grid-cols-2 gap-4 min-h-40">
                  {/* Urgent & Important */}
                  <div 
                    className="bg-red-100 rounded-xl p-3 flex flex-col justify-center items-center cursor-pointer hover:bg-red-200 transition-all duration-200 hover:scale-105 shadow-sm hover:shadow-md"
                    onClick={() => setSelectedPriorityCategory(selectedPriorityCategory === 'urgent-important' ? null : 'urgent-important')}
                  >
                    <AlertTriangle className="w-8 h-8 text-red-600 mb-2" />
                    <div className="text-lg font-bold text-red-700">
                      {getTasksByPriorityCategory('urgent-important').length}
                    </div>
                    <div className="text-xs text-red-600 text-center">דחוף וחשוב</div>
                  </div>
                  
                  {/* Important but Not Urgent */}
                  <div 
                    className="bg-yellow-100 rounded-xl p-3 flex flex-col justify-center items-center cursor-pointer hover:bg-yellow-200 transition-all duration-200 hover:scale-105 shadow-sm hover:shadow-md"
                    onClick={() => setSelectedPriorityCategory(selectedPriorityCategory === 'important-not-urgent' ? null : 'important-not-urgent')}
                  >
                    <Star className="w-8 h-8 text-yellow-600 mb-2" />
                    <div className="text-lg font-bold text-yellow-700">
                      {getTasksByPriorityCategory('important-not-urgent').length}
                    </div>
                    <div className="text-xs text-yellow-600 text-center">חשוב לא דחוף</div>
                  </div>
                  
                  {/* Urgent but Not Important */}
                  <div 
                    className="bg-orange-100 rounded-xl p-3 flex flex-col justify-center items-center cursor-pointer hover:bg-orange-200 transition-all duration-200 hover:scale-105 shadow-sm hover:shadow-md"
                    onClick={() => setSelectedPriorityCategory(selectedPriorityCategory === 'urgent-not-important' ? null : 'urgent-not-important')}
                  >
                    <Clock className="w-8 h-8 text-orange-600 mb-2" />
                    <div className="text-lg font-bold text-orange-700">
                      {getTasksByPriorityCategory('urgent-not-important').length}
                    </div>
                    <div className="text-xs text-orange-600 text-center">דחוף לא חשוב</div>
                  </div>
                  
                  {/* Neither Urgent nor Important */}
                  <div 
                    className="bg-gray-100 rounded-xl p-3 flex flex-col justify-center items-center cursor-pointer hover:bg-gray-200 transition-all duration-200 hover:scale-105 shadow-sm hover:shadow-md"
                    onClick={() => setSelectedPriorityCategory(selectedPriorityCategory === 'neither' ? null : 'neither')}
                  >
                    <PauseCircle className="w-8 h-8 text-gray-600 mb-2" />
                    <div className="text-lg font-bold text-gray-700">
                      {getTasksByPriorityCategory('neither').length}
                    </div>
                    <div className="text-xs text-gray-600 text-center">לא דחוף לא חשוב</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        )}

        {/* Priority Tasks Detail */}
        {selectedPriorityCategory && (
          <div className="mt-8">
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl text-white">
                    <CheckSquare className="w-5 h-5" />
                  </div>
                  משימות - {getPriorityCategoryName(selectedPriorityCategory)}
                </h3>
                <button 
                  onClick={() => setSelectedPriorityCategory(null)}
                  className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
                  title="סגור"
                >
                  <span className="text-gray-600 text-xl">×</span>
                </button>
              </div>
              
              <div className="space-y-4">
                {getTasksByPriorityCategory(selectedPriorityCategory).length > 0 ? (
                  getTasksByPriorityCategory(selectedPriorityCategory).map((task, index) => {
                    const assignee = users.find(u => u.id === task.assigneeId);
                    const department = departments.find(d => d.id === task.departmentId);
                    const team = teams.find(t => t.id === task.teamId);
                    
                    return (
                      <div 
                        key={index}
                        className="p-4 bg-gray-50/80 rounded-2xl border border-gray-200/50 cursor-pointer hover:bg-gray-100/80 transition-all duration-200 hover:shadow-md"
                        onClick={() => handleNavigateToTask(task.id)}
                      >
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex-1">
                            <h4 className="font-semibold text-gray-900 mb-1">{task.title}</h4>
                            <p className="text-sm text-gray-600 mb-2">{task.description}</p>
                            <div className="flex items-center gap-4 text-xs text-gray-500">
                              {assignee && (
                                <span>👤 {assignee.name}</span>
                              )}
                              {department && (
                                <span>🏢 {department.name}</span>
                              )}
                              {team && (
                                <span>👥 {team.name}</span>
                              )}
                              {task.dueDate && (
                                <span>📅 {new Date(task.dueDate).toLocaleDateString('he-IL')}</span>
                              )}
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                              task.status === 'הושלם' ? 'bg-green-100 text-green-800' :
                              task.status === 'במסלול' ? 'bg-blue-100 text-blue-800' :
                              task.status === 'ממתין לעבודה' ? 'bg-orange-100 text-orange-800' :
                              'bg-gray-100 text-gray-800'
                            }`}>
                              {task.status}
                            </span>
                            <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                              task.priority === 'high' ? 'bg-red-100 text-red-800' :
                              task.priority === 'medium' ? 'bg-yellow-100 text-yellow-800' :
                              'bg-gray-100 text-gray-800'
                            }`}>
                              {task.priority === 'high' ? 'גבוהה' : 
                               task.priority === 'medium' ? 'בינונית' : 'נמוכה'}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center py-8 text-gray-500">
                    <CheckSquare className="w-12 h-12 mx-auto mb-4 text-gray-400" />
                    <p>אין משימות בקטגוריה זו</p>
                    <p className="text-sm">המשימות יופיעו כאן כשתצור משימות עם העדיפות המתאימה</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* SOP Section - Enhanced */}
        {selectedDataType === 'sop' && (
          <div className="mt-8">
            <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl text-white">
                    <Activity className="w-5 h-5" />
                  </div>
                  תהליכי SOP
                </h3>
                <div className="flex items-center gap-2">
                  <button 
                    onClick={handleCreateSOP}
                    className="px-4 py-2 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors text-sm"
                  >
                    צור תהליך חדש
                  </button>
                  <button className="p-2 hover:bg-gray-100 rounded-xl transition-colors">
                    <Download className="w-5 h-5 text-gray-600" />
                  </button>
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center p-6 bg-purple-50 rounded-2xl">
                  <Activity className="w-12 h-12 mx-auto mb-4 text-purple-600" />
                  <div className="text-2xl font-bold text-purple-600 mb-2">0</div>
                  <div className="text-sm text-gray-600">תהליכים פעילים</div>
                </div>
                <div className="text-center p-6 bg-green-50 rounded-2xl">
                  <CheckCircle className="w-12 h-12 mx-auto mb-4 text-green-600" />
                  <div className="text-2xl font-bold text-green-600 mb-2">0</div>
                  <div className="text-sm text-gray-600">הושלמו השבוע</div>
                </div>
                <div className="text-center p-6 bg-orange-50 rounded-2xl">
                  <Clock className="w-12 h-12 mx-auto mb-4 text-orange-600" />
                  <div className="text-2xl font-bold text-orange-600 mb-2">0</div>
                  <div className="text-sm text-gray-600">זמן ממוצע</div>
                </div>
              </div>
            </div>
          </div>
        )}

{/* Weekly Plans Section - עם עריכה וגרירה! */}
<div className="mt-8">
  <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20">
    <div className="p-8 border-b border-gray-100/50 bg-gradient-to-r from-green-50/50 to-blue-50/50">
      <h3 className="text-2xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
        תכנון שבועי אישי
      </h3>
      <p className="text-gray-600 mt-2 text-lg">
        לוח שנה שבועי עם כל המשימות שלך ✨
      </p>
      <div className="mt-4 flex items-center gap-4">
        <button
          onClick={() => setShowWeeklyTaskSelector(!showWeeklyTaskSelector)}
          className={`px-4 py-2 rounded-xl transition-colors flex items-center gap-2 ${
            showWeeklyTaskSelector
              ? 'bg-orange-500 text-white hover:bg-orange-600'
              : 'bg-green-600 text-white hover:bg-green-700'
          }`}
        >
          <Plus className="w-5 h-5" />
          {showWeeklyTaskSelector ? 'סגור' : 'הוסף משימה ללוח'}
        </button>
        
        {/* כפתור עריכה חדש! */}
        <button
          onClick={() => setIsEditingCalendar(!isEditingCalendar)}
          className={`px-4 py-2 rounded-xl transition-colors flex items-center gap-2 ${
            isEditingCalendar 
              ? 'bg-orange-500 text-white hover:bg-orange-600 animate-pulse' 
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
        >
          <Edit2 className="w-5 h-5" />
          {isEditingCalendar ? 'סיים עריכה' : 'ערוך לוח שבועי'}
        </button>
        
        <button
          onClick={() => {
            const newWeek = new Date(currentWeekStart);
            newWeek.setDate(newWeek.getDate() - 7);
            setCurrentWeekStart(getWeekStart(newWeek));
          }}
          className="px-4 py-2 bg-gray-600 text-white rounded-xl hover:bg-gray-700 transition-colors"
        >
          שבוע קודם
        </button>
        <button
          onClick={() => setCurrentWeekStart(getWeekStart(new Date()))}
          className="px-4 py-2 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors"
        >
          השבוע
        </button>
        <button
          onClick={() => {
            const newWeek = new Date(currentWeekStart);
            newWeek.setDate(newWeek.getDate() + 7);
            setCurrentWeekStart(getWeekStart(newWeek));
          }}
          className="px-4 py-2 bg-gray-600 text-white rounded-xl hover:bg-gray-700 transition-colors"
        >
          שבוע הבא
        </button>
      </div>
      
      {/* הודעת מצב עריכה */}
      {isEditingCalendar && (
        <div className="mt-4 p-3 bg-yellow-100 rounded-lg border border-yellow-400">
          <p className="text-sm text-yellow-800 font-medium">
            📝 מצב עריכה פעיל - גרור משימות למיקום חדש בלוח
          </p>
        </div>
      )}
    </div>
    
    <div className="p-8">
      {/* רשימת משימות זמינות - רק כש showWeeklyTaskSelector פעיל */}
      {showWeeklyTaskSelector && (
        <div className="mb-6 bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-6 border-2 border-green-300">
          <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
            <CheckSquare className="w-6 h-6 text-green-600" />
            גרור משימות ללוח
          </h4>
          
          {/* סינון */}
          <div className="mb-4 space-y-3">
            <input
              type="text"
              placeholder="חפש משימה..."
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
              onChange={(e) => {
                const searchValue = e.target.value.toLowerCase();
                const taskElements = document.querySelectorAll('[data-weekly-task-item]');
                taskElements.forEach(el => {
                  const title = el.getAttribute('data-weekly-task-title').toLowerCase();
                  el.style.display = title.includes(searchValue) ? 'block' : 'none';
                });
              }}
            />
            
            <div className="grid grid-cols-3 gap-2">
              {/* פילטר המשימות שלי */}
              <select
                value={weeklyFilterMyTasks ? 'my' : 'all'}
                onChange={(e) => setWeeklyFilterMyTasks(e.target.value === 'my')}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 text-sm font-semibold"
              >
                <option value="my">המשימות שלי</option>
                <option value="all">כל המשימות</option>
              </select>
              
              {/* פילטר מחלקה */}
              <select
                value={weeklyFilterDepartment}
                onChange={(e) => setWeeklyFilterDepartment(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 text-sm"
              >
                <option value="">כל המחלקות</option>
                {departments.map(dept => (
                  <option key={dept.id} value={dept.id}>{dept.name}</option>
                ))}
              </select>
              
              {/* פילטר פרויקט */}
              <select
                value={weeklyFilterProject}
                onChange={(e) => setWeeklyFilterProject(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 text-sm"
              >
                <option value="">כל הפרויקטים</option>
                {projects.map(proj => (
                  <option key={proj.id} value={proj.id}>{proj.name}</option>
                ))}
              </select>
            </div>
          </div>
          
          {/* רשימת משימות */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 max-h-[300px] overflow-y-auto">
            {tasks
              .filter(task => !weeklyFilterMyTasks || task.assignedTo === currentUser?.id || task.createdBy === currentUser?.id)
              .filter(task => task.status !== 'הושלם')
              .filter(task => !weeklyFilterDepartment || task.departmentId === weeklyFilterDepartment)
              .filter(task => !weeklyFilterProject || task.projectId === weeklyFilterProject)
              .map(task => (
                <div
                  key={task.id}
                  data-weekly-task-item
                  data-weekly-task-title={task.title}
                  draggable
                  onDragStart={(e) => {
                    e.dataTransfer.setData('weeklyTaskId', task.id);
                    e.dataTransfer.setData('weeklyTaskData', JSON.stringify(task));
                  }}
                  className="p-3 bg-white border-2 border-green-200 rounded-xl cursor-move hover:shadow-lg transition-all hover:scale-105"
                >
                  <div className="flex items-center gap-2">
                    <div className="text-xl">📋</div>
                    <div className="flex-1 min-w-0">
                      <h5 className="font-semibold text-sm text-gray-900 truncate">{task.title}</h5>
                      {task.priority && (
                        <span className={`text-xs px-2 py-0.5 rounded-full inline-block mt-1 ${
                          task.priority === 'high' ? 'bg-red-100 text-red-700' :
                          task.priority === 'medium' ? 'bg-yellow-100 text-yellow-700' :
                          'bg-green-100 text-green-700'
                        }`}>
                          {task.priority === 'high' ? 'דחוף' : task.priority === 'medium' ? 'בינוני' : 'רגיל'}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      )}
      
      {(() => {
        // חישוב תחילת השבוע הנכון (תמיד יום ראשון)
        const weekStartDate = new Date(currentWeekStart);
        const day = weekStartDate.getDay();
        if (day !== 0) {
          weekStartDate.setDate(weekStartDate.getDate() - day);
        }
        const weekStartStr = weekStartDate.toISOString().split('T')[0];
        
        // טעינת התכנון מ-localStorage
   const savedPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
const currentPlanIndex = savedPlans.findIndex(plan => {
  const planStart = plan.summaryData?.weekStart?.split('T')[0];
  return (plan.userId === currentUser?.id || 
          plan.userId === currentUser?.uid || 
          plan.userName === currentUser?.name) &&
         planStart === weekStartStr;
});
        
        const currentPlan = currentPlanIndex >= 0 ? savedPlans[currentPlanIndex] : null;
        let weekSchedule = weeklyScheduleState && Object.keys(weeklyScheduleState).length > 0 
          ? weeklyScheduleState 
          : (currentPlan?.summaryData?.schedule || {});

        // הוספת ישיבות מאושרות ללוח השבועי
        if (currentUser && meetings && meetings.length > 0) {
          weekSchedule = { ...weekSchedule }; // העתק כדי לא לשנות את המקור
          
          const confirmedMeetings = meetings.filter(meeting => {
            // רק ישיבות מתוכננות שהמשתמש אישר הגעה
            if (meeting.status !== 'scheduled') return false;
            if (!meeting.confirmedParticipantIds || !meeting.confirmedParticipantIds.includes(currentUser.id)) return false;
            if (!meeting.startDate) return false;

            // בדיקה שהישיבה בטווח השבוע הנוכחי
            const meetingDate = meeting.startDate.toDate ? meeting.startDate.toDate() : new Date(meeting.startDate);
            const weekEnd = new Date(weekStartDate);
            weekEnd.setDate(weekEnd.getDate() + 7);
            return meetingDate >= weekStartDate && meetingDate < weekEnd;
          });

          console.log('🔵 Found', confirmedMeetings.length, 'confirmed meetings for current week');

          // הוספת כל ישיבה ללוח
          confirmedMeetings.forEach(meeting => {
            const meetingDate = meeting.startDate.toDate ? meeting.startDate.toDate() : new Date(meeting.startDate);
            const meetingEndDate = meeting.endDate ? (meeting.endDate.toDate ? meeting.endDate.toDate() : new Date(meeting.endDate)) : null;
            const dateStr = meetingDate.toISOString().split('T')[0];

            if (!weekSchedule[dateStr]) {
              weekSchedule[dateStr] = {};
            }

            // חישוב כל השעות שהישיבה תופסת
            const startHour = meetingDate.getHours();
            const startMinute = meetingDate.getMinutes();
            const endHour = meetingEndDate ? meetingEndDate.getHours() : startHour + 1;
            const endMinute = meetingEndDate ? meetingEndDate.getMinutes() : 0;

            // כל ה-timeSlots האפשריים בלוח
            const allTimeSlots = ['06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', 
              '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', 
              '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', 
              '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00'];

            // המרה לדקות
            const startTotalMinutes = startHour * 60 + startMinute;
            const endTotalMinutes = endHour * 60 + endMinute;

            console.log(`📅 Meeting: ${meeting.subject}, Start: ${startHour}:${startMinute}, End: ${endHour}:${endMinute}`);

            let isFirst = true;
            // מציאת כל ה-timeSlots שהישיבה חופפת אליהם
            allTimeSlots.forEach(slot => {
              const [slotHour, slotMinute] = slot.split(':').map(Number);
              const slotTotalMinutes = slotHour * 60 + slotMinute;

              // בדיקה אם ה-slot נמצא בטווח הישיבה
              if (slotTotalMinutes >= startTotalMinutes && slotTotalMinutes < endTotalMinutes) {
                weekSchedule[dateStr][slot] = {
                  title: isFirst ? `📅 ${meeting.subject}` : '⬇️ המשך ישיבה',
                  description: isFirst ? meeting.purpose : `המשך: ${meeting.subject}`,
                  type: 'meeting',
                  meetingId: meeting.id,
                  priority: 'urgent',
                  location: isFirst ? meeting.location : null,
                  // אל תשים duration - זה גורם לבאג בחישוב isContinuation
                  isContinuation: !isFirst,
                  isMeetingSlot: true, // סימון מיוחד שזה slot של ישיבה
                  originalMeetingSubject: meeting.subject,
                  locked: true // נעל את הישיבה מפני עריכה
                };
                console.log(`  ✅ Added to slot: ${slot}, isFirst: ${isFirst}`);
                isFirst = false;
              }
            });
          });
        }

        // הוספת שגרות יומיות ללוח השבועי
        if (currentUser && dailyRoutines && dailyRoutines.length > 0) {
          weekSchedule = { ...weekSchedule }; // העתק כדי לא לשנות את המקור
          
          console.log('🔵 Processing', dailyRoutines.length, 'daily routines for the week');
          console.log('📅 Week start:', weekStartDate.toISOString().split('T')[0]);

          // עבור כל יום בשבוע
          for (let dayOffset = 0; dayOffset < 7; dayOffset++) {
            const checkDate = new Date(weekStartDate);
            checkDate.setDate(checkDate.getDate() + dayOffset);
            const dateStr = checkDate.toISOString().split('T')[0];

            // מצא שגרות שמתוזמנות ליום זה
            const routinesForDay = dailyRoutines.filter(routine => 
              isRoutineScheduledForDate(routine, checkDate)
            );

            if (routinesForDay.length > 0) {
              console.log(`📅 Found ${routinesForDay.length} routines for ${dateStr}`);
            }

            // הוסף כל שגרה ללוח
            routinesForDay.forEach(routine => {
              if (!weekSchedule[dateStr]) {
                weekSchedule[dateStr] = {};
              }

              // חלץ שעה ודקה מ-dueTime (פורמט: "HH:MM")
              const [routineHour, routineMinute] = (routine.dueTime || '09:00').split(':').map(Number);
              
              // מצא את ה-slot הקרוב ביותר (כל חצי שעה)
              const roundedMinute = routineMinute < 30 ? '00' : '30';
              const timeSlot = `${String(routineHour).padStart(2, '0')}:${roundedMinute}`;

              // אם ה-slot כבר תפוס, אל תדרוס אותו
              if (weekSchedule[dateStr][timeSlot]) {
                console.log(`⚠️ Slot ${timeSlot} already occupied on ${dateStr}, skipping routine ${routine.name}`);
                return;
              }

              // קביעת משך זמן משוער (בשעות)
              const estimatedHours = routine.estimatedTime ? routine.estimatedTime / 60 : 0.5;

              weekSchedule[dateStr][timeSlot] = {
                title: `🔄 ${routine.name}`,
                description: routine.description || `שגרה יומית: ${routine.name}`,
                type: 'routine',
                routineId: routine.id,
                priority: routine.priority || 'medium',
                duration: estimatedHours,
                isRoutineSlot: true, // סימון מיוחד שזה slot של שגרה
                routineName: routine.name,
                routineFrequency: routine.frequency,
                locked: false // שגרות ניתנות לעריכה בלוח (בניגוד לישיבות)
              };

              console.log(`  ✅ Added routine "${routine.name}" to ${dateStr} at ${timeSlot}`);
            });
          }
        }
        
        // פונקציות דראג אנד דרופ
        const handleDragStart = (e, task, dateStr, timeSlot) => {
          if (!isEditingCalendar) return;
          // אל תאפשר גרירה של ישיבות
          if (task.type === 'meeting') {
            e.preventDefault();
            alert('❌ לא ניתן לגרור ישיבות מתוכננות');
            return;
          }
          setDraggedTask({ task, dateStr, timeSlot });
          e.dataTransfer.effectAllowed = 'move';
          e.currentTarget.style.opacity = '0.5';
        };
        
        const handleDragEnd = (e) => {
          e.currentTarget.style.opacity = '1';
        };
        
        const handleDragOver = (e) => {
          // אפשר גרירה במצב עריכה או כאשר פתוח בוחר המשימות
          if (!isEditingCalendar && !showWeeklyTaskSelector) return;
          e.preventDefault();
          e.dataTransfer.dropEffect = 'move';
          e.currentTarget.style.backgroundColor = '#e0f2fe'; // bg-blue-100
        };
        
        const handleDragLeave = (e) => {
          e.currentTarget.style.backgroundColor = '';
        };
        
        const handleDrop = (e, newDateStr, newTimeSlot) => {
          e.preventDefault();
          e.currentTarget.style.backgroundColor = '';
          
          // בדיקה אם זה משימה מהרשימה או משימה קיימת בלוח
          const weeklyTaskData = e.dataTransfer.getData('weeklyTaskData');
          
          if (weeklyTaskData) {
            // משימה חדשה מהרשימה
            const newTask = JSON.parse(weeklyTaskData);
            
            // בדיקה שהמקום פנוי
            if (weekSchedule[newDateStr]?.[newTimeSlot]) {
              alert('⚠️ המיקום תפוס! בחר מקום פנוי.');
              return;
            }
            
            // עדכון הלוח
            const updatedSchedule = JSON.parse(JSON.stringify(weekSchedule)); // Deep copy
            
            // הוספה למיקום החדש
            if (!updatedSchedule[newDateStr]) {
              updatedSchedule[newDateStr] = {};
            }
            updatedSchedule[newDateStr][newTimeSlot] = {
              ...newTask,
              duration: 1
            };
            
            // שמירה או יצירת תכנון
            if (currentPlanIndex >= 0) {
              savedPlans[currentPlanIndex].summaryData.schedule = updatedSchedule;
              savedPlans[currentPlanIndex].updatedAt = new Date().toISOString();
            } else {
              // צור תכנון חדש
              const newPlan = {
                id: Date.now().toString(),
                userId: currentUser?.id,
                userName: currentUser?.name,
                savedAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                type: 'weekly_planning',
                summaryData: {
                  weekStart: weekStartStr,
                  schedule: updatedSchedule
                }
              };
              savedPlans.push(newPlan);
            }
            
            localStorage.setItem('weeklyPlans', JSON.stringify(savedPlans));
            
            // עדכון state במקום reload
            setWeeklyScheduleState(updatedSchedule);
            return;
          }
          
          // טיפול בגרירה של משימה קיימת בלוח
          if (!isEditingCalendar || !draggedTask) return;
          
          const { task, dateStr: oldDateStr, timeSlot: oldTimeSlot } = draggedTask;
          
          // בדיקה שהמקום פנוי
          if (weekSchedule[newDateStr]?.[newTimeSlot]) {
            alert('⚠️ המיקום תפוס! בחר מקום פנוי.');
            return;
          }
          
          // עדכון הלוח
          const updatedSchedule = JSON.parse(JSON.stringify(weekSchedule)); // Deep copy
          
          // הסרה מהמיקום הישן
          if (updatedSchedule[oldDateStr]) {
            delete updatedSchedule[oldDateStr][oldTimeSlot];
          }
          
          // הוספה למיקום החדש
          if (!updatedSchedule[newDateStr]) {
            updatedSchedule[newDateStr] = {};
          }
          updatedSchedule[newDateStr][newTimeSlot] = task;
          
          // שמירה ב-localStorage
          if (currentPlanIndex >= 0) {
            savedPlans[currentPlanIndex].summaryData.schedule = updatedSchedule;
            savedPlans[currentPlanIndex].updatedAt = new Date().toISOString();
            localStorage.setItem('weeklyPlans', JSON.stringify(savedPlans));
          }
          
          // עדכון state במקום reload
          setWeeklyScheduleState(updatedSchedule);
          setDraggedTask(null);
        };
        
        // יצירת תאריכי השבוע
        const weekDates = [];
        for (let i = 0; i < 7; i++) {
          const date = new Date(weekStartDate);
          date.setDate(weekStartDate.getDate() + i);
          weekDates.push(date);
        }
        
        // חישוב סה"כ משימות
        let totalTasks = 0;
        Object.values(weekSchedule).forEach(day => {
          Object.values(day || {}).forEach(task => {
            if (task && task.title) totalTasks++;
          });
        });
        
        return (
          <div className="bg-white rounded-2xl overflow-hidden">
            {/* כותרת עם תאריכים */}
            <div className="grid grid-cols-8 gap-0 bg-gray-50 border-b-2 border-gray-200">
              <div className="p-4 text-center border-r border-gray-200 bg-gray-100">
                <Clock className="w-5 h-5 mx-auto mb-1 text-gray-600" />
                <span className="text-sm font-bold">שעה</span>
              </div>
              {['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'].map((dayName, index) => {
                const date = weekDates[index];
                const isToday = date.toDateString() === new Date().toDateString();
                return (
                  <div key={index} className={`p-4 text-center border-r border-gray-200 ${
                    isToday ? 'bg-blue-100' : ''
                  }`}>
                    <div className="font-bold text-sm">{dayName}</div>
                    <div className="text-xs text-gray-600">
                      {date.getDate()}/{date.getMonth() + 1}
                    </div>
                    {isToday && (
                      <div className="text-xs text-blue-600 font-bold mt-1">(היום)</div>
                    )}
                  </div>
                );
              })}
            </div>
            
            {/* גוף הלוח - שעות ומשימות */}
<div className="max-h-[600px] overflow-y-auto">
  {['06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', 
    '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', 
    '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', 
    '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', 
    '22:00'].map(timeSlot => (
    <div key={timeSlot} className="grid grid-cols-8 gap-0 border-b border-gray-200 hover:bg-gray-50">
      <div className="p-3 text-center bg-gray-50 border-r border-gray-200 font-medium">
        {timeSlot}
      </div>
      {weekDates.map((date, dayIndex) => {
        const dateStr = date.toISOString().split('T')[0];
        const task = weekSchedule[dateStr]?.[timeSlot];
        const isToday = date.toDateString() === new Date().toDateString();
        
        // בדיקה אם השעה הזו היא המשך של משימה קודמת
        const isContinuation = (() => {
          if (!weekSchedule[dateStr]) return false;
          
          // אם זה ישיבה, היא כבר מסומנת כ-isContinuation במפורש
          const currentTask = weekSchedule[dateStr][timeSlot];
          if (currentTask && currentTask.isMeetingSlot) {
            return currentTask.isContinuation || false;
          }
          
          const allTimeSlots = ['06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', 
            '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', 
            '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', 
            '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00'];
          
          const currentIndex = allTimeSlots.indexOf(timeSlot);
          
          // בדוק אם יש משימה בשעות קודמות עם duration שמכסה את השעה הנוכחית
          // אבל התעלם מישיבות - הן כבר מטופלות
          for (let i = 0; i < currentIndex; i++) {
            const prevTask = weekSchedule[dateStr][allTimeSlots[i]];
            if (prevTask && prevTask.duration && !prevTask.isMeetingSlot) {
              const slotsNeeded = Math.ceil(prevTask.duration * 2);
              if (i + slotsNeeded > currentIndex) {
                return true;
              }
            }
          }
          return false;
        })();
        
        return (
          <div 
            key={`${dateStr}-${timeSlot}`} 
            data-time-slot={`${dateStr}-${timeSlot}`}
            className={`p-2 min-h-[60px] border-r border-gray-200 ${
              isToday ? 'bg-blue-50/20' : 'bg-white'
            } ${isEditingCalendar && !isContinuation ? 'hover:bg-gray-100' : ''} ${
              isContinuation ? 'bg-gray-100' : ''
            }`}
            onDragOver={!isContinuation ? handleDragOver : undefined}
            onDragLeave={!isContinuation ? handleDragLeave : undefined}
            onDrop={!isContinuation ? (e) => handleDrop(e, dateStr, timeSlot) : undefined}
          >
            {isContinuation && !task?.isMeetingSlot ? (
              <div className="text-xs text-gray-500 text-center p-1">
                ↓ המשך משימה ↓
              </div>
            ) : task && task.title ? (
              <div 
                draggable={isEditingCalendar && task.type !== 'meeting'}
                onDragStart={(e) => handleDragStart(e, task, dateStr, timeSlot)}
                onDragEnd={handleDragEnd}
                className={`p-2 rounded-lg text-xs hover:shadow-lg transition-all transform hover:scale-105 ${
                  isEditingCalendar && task.type !== 'meeting' && task.type !== 'routine' ? 'cursor-move' : 'cursor-pointer'
                } ${
                  task.type === 'meeting' ? 'bg-purple-100 border-l-4 border-purple-600 text-purple-900' :
                  task.type === 'routine' ? 'bg-teal-100 border-l-4 border-teal-600 text-teal-900' :
                  task.priority === 'high' || task.priority === 'urgent' ? 'bg-red-100 border-l-4 border-red-500 text-red-800' :
                  task.priority === 'medium' ? 'bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800' :
                  'bg-green-100 border-l-4 border-green-500 text-green-800'
                }`}
                onClick={() => {
                  if (!isEditingCalendar) {
                    if (task.type === 'meeting' && task.meetingId) {
                      navigate(`/meetings/${task.meetingId}`);
                    } else if (task.id) {
                      handleNavigateToTask(task.id);
                    }
                  }
                }}
              >
                <div className="font-bold truncate">{task.title}</div>
                {task.description && !task.isContinuation && (
                  <div className="text-xs opacity-75 mt-1 truncate">
                    {task.description}
                  </div>
                )}
                {task.project && (
                  <div className="text-xs opacity-75 mt-1 truncate">
                    פרויקט: {task.project}
                  </div>
                )}
                {task.location && !task.isContinuation && (
                  <div className="text-xs opacity-75 mt-1 truncate">
                    📍 {task.location}
                  </div>
                )}
                
                {/* הצגת משך זמן */}
                {task.duration && !task.isContinuation && (
                  <div className="text-xs opacity-75 mt-1">
                    ⏱️ {task.duration} שעות
                  </div>
                )}
                
                {/* סימון לישיבה */}
                {task.type === 'meeting' && !task.isContinuation && (
                  <div className="mt-1 px-2 py-1 bg-purple-200 text-purple-900 rounded text-xs font-bold">
                    ✅ ישיבה מאושרת
                  </div>
                )}
                
                {/* סימון לשגרה */}
                {task.type === 'routine' && (
                  <div className="mt-1 px-2 py-1 bg-teal-200 text-teal-900 rounded text-xs font-bold">
                    🔄 שגרה {task.routineFrequency === 'weekly' ? 'שבועית' : task.routineFrequency === 'monthly' ? 'חודשית' : 'יומית'}
                  </div>
                )}
                
                {/* אזור גרירה ומחיקה - רק במצב עריכה ולא לישיבות או שגרות */}
                {isEditingCalendar && task.type !== 'meeting' && task.type !== 'routine' && (
                  <>
                    <div className="text-xs mt-1 opacity-75">
                      ✋ גרור למקום חדש
                    </div>
                    
                    {/* כפתור מחיקה - שלב 3 */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        
                        if (window.confirm('האם למחוק את המשימה מהלוח?')) {
                          // מחיקה מהלוח השבועי
                          const updatedSchedule = { ...weeklyScheduleState };
                          if (!updatedSchedule[dateStr]) {
                            updatedSchedule[dateStr] = {};
                          }
                          delete updatedSchedule[dateStr][timeSlot];
                          
                          // שמירה ב-localStorage - תכנון שבועי
                          const weeklyPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
                          const weekStartDate = new Date(currentWeekStart);
                          const day = weekStartDate.getDay();
                          if (day !== 0) {
                            weekStartDate.setDate(weekStartDate.getDate() - day);
                          }
                          const weekStartStr = weekStartDate.toISOString().split('T')[0];
                          
                          const planIndex = weeklyPlans.findIndex(p => 
                            (p.userId === currentUser?.id || p.userName === currentUser?.name) &&
                            p.summaryData?.weekStart === weekStartStr
                          );
                          
                          if (planIndex >= 0) {
                            weeklyPlans[planIndex].summaryData.schedule = updatedSchedule;
                            weeklyPlans[planIndex].updatedAt = new Date().toISOString();
                            localStorage.setItem('weeklyPlans', JSON.stringify(weeklyPlans));
                          }
                          
                          // סנכרון עם תכנון יומי
                          const dailyPlans = JSON.parse(localStorage.getItem('dailyPlans') || '[]');
                          const dailyPlanIndex = dailyPlans.findIndex(p => 
                            p.date === dateStr && 
                            (p.userId === currentUser?.id || 
                             p.userId === currentUser?.uid ||
                             p.userName === currentUser?.name)
                          );
                          
                          if (dailyPlanIndex >= 0) {
                            if (dailyPlans[dailyPlanIndex].schedule && 
                                dailyPlans[dailyPlanIndex].schedule[timeSlot]) {
                              delete dailyPlans[dailyPlanIndex].schedule[timeSlot];
                              dailyPlans[dailyPlanIndex].updatedAt = new Date().toISOString();
                              localStorage.setItem('dailyPlans', JSON.stringify(dailyPlans));
                            }
                          }
                          
                          // עדכון ה-state
                          setWeeklyScheduleState(updatedSchedule);
                          
                          alert('המשימה נמחקה מהלוח בהצלחה!');
                        }
                      }}
                      className="mt-2 w-full px-2 py-1 bg-red-100 hover:bg-red-200 rounded text-red-600 text-xs flex items-center justify-center gap-1 transition-colors"
                    >
                      <Trash2 className="w-3 h-3" />
                      מחק
                    </button>
                  </>
                )}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  ))}
</div>
            
            {/* סיכום תחתון */}
            <div className="p-4 bg-gradient-to-r from-green-50 to-blue-50 border-t-2 border-gray-200">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-4">
                  <div className="text-sm text-gray-600">
                    <span className="font-bold">סה"כ משימות השבוע:</span>
                    <span className="text-2xl font-bold text-blue-600 mr-2">{totalTasks}</span>
                  </div>
                  {currentPlan && (
                    <div className="text-xs text-gray-500">
                      עודכן לאחרונה: {new Date(currentPlan.savedAt || currentPlan.updatedAt).toLocaleString('he-IL')}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  </div>
</div>
{/* Daily Plan Summary Section - סיכום תכנון יומי משופר */}
<div className="mt-8">
  <div className="bg-gradient-to-br from-white via-blue-50/30 to-indigo-50/30 rounded-3xl shadow-2xl border border-blue-200/30 overflow-hidden">
    <div className="p-8 bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-3xl font-bold flex items-center gap-3">
            <Calendar className="w-8 h-8" />
            לוח זמנים - {new Date().toLocaleDateString('he-IL', { weekday: 'long', day: 'numeric', month: 'long' })}
          </h3>
          <p className="mt-2 text-blue-100">
            המשימות שלך להיום מסודרות לפי שעות
          </p>
        </div>
        <div className="text-right">
          <div className="text-3xl font-bold">
            {new Date().toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' })}
          </div>
          <div className="text-sm text-blue-100">השעה כרגע</div>
        </div>
      </div>
    </div>
    
    <div className="p-8">
      {/* אינדיקטור מצב עריכה */}
      {isEditingCalendar && (
        <div className="mb-6 bg-gradient-to-r from-yellow-400 via-yellow-500 to-orange-500 text-white rounded-2xl p-6 shadow-lg border-4 border-yellow-600 animate-pulse">
          <div className="flex items-center justify-center gap-3">
            <Edit2 className="w-8 h-8" />
            <div className="text-center">
              <h3 className="text-2xl font-bold">מצב עריכה פעיל</h3>
              <p className="text-sm mt-1">אתה יכול עכשיו למחוק, להזיז ולהוסיף משימות</p>
            </div>
            <Edit2 className="w-8 h-8" />
          </div>
        </div>
      )}
      
      {(() => {
        const today = new Date().toISOString().split('T')[0];
        const currentTime = new Date().getHours() + ':' + String(new Date().getMinutes()).padStart(2, '0');
        
        // איסוף כל המשימות מתכנון יומי ושבועי
        const allTasks = {};
        
        // משימות מתכנון יומי
     const todayPlan = dailyPlans.find(plan => 
  plan.date === today && 
  (plan.userId === currentUser?.id || 
   plan.userId === currentUser?.uid ||
   plan.userName === currentUser?.name)
);
        
        if (todayPlan?.schedule) {
          console.log('📋 תכנון יומי נמצא:', todayPlan);
          console.log('🕐 Schedule:', todayPlan.schedule);
          Object.entries(todayPlan.schedule).forEach(([time, slot]) => {
            console.log(`   ${time}:`, slot);
            if (slot?.task) {
              allTasks[time] = { 
                ...slot.task, 
                source: 'daily',
                duration: slot.duration || 1
              };
            }
          });
          console.log('✅ סה"כ משימות שנטענו:', Object.keys(allTasks).length);
        } else {
          console.log('⚠️ אין תכנון יומי היום');
        }
        
        // משימות מתכנון שבועי
        const weeklyPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
        weeklyPlans.forEach(plan => {
          if (plan.summaryData?.schedule?.[today]) {
            Object.entries(plan.summaryData.schedule[today]).forEach(([time, task]) => {
              if (task && !allTasks[time]) {
                allTasks[time] = { 
                  ...task, 
                  source: 'weekly',
                  duration: task.duration || 1
                };
              }
            });
          }
        });
        
        const sortedTimes = Object.keys(allTasks).sort();
        const totalTasks = sortedTimes.length;
        
        if (totalTasks === 0) {
          return (
            <div className="text-center py-16">
              <div className="inline-flex items-center justify-center w-24 h-24 bg-gray-100 rounded-full mb-6">
                <Calendar className="w-12 h-12 text-gray-400" />
              </div>
              <p className="text-gray-500 text-xl mb-6">עדיין לא תכננת את היום</p>
              <button
                onClick={() => {
                  setShowDailyPlanner(true);
                  setPlanningType('daily');
                }}
                className="px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-2xl hover:from-blue-700 hover:to-indigo-700 font-semibold shadow-lg transform hover:scale-105 transition-all"
              >
                תכנן את היום שלך
              </button>
            </div>
          );
        }
        
        return (
          <div>
            {/* סטטיסטיקות יום */}
            <div className="grid grid-cols-4 gap-4 mb-8">
              <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                <div className="text-3xl font-bold text-gray-900">{totalTasks}</div>
                <div className="text-sm text-gray-600 mt-1">משימות להיום</div>
              </div>
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 shadow-lg border border-green-200">
                <div className="text-3xl font-bold text-green-600">
                  {sortedTimes.filter(time => time < currentTime).length}
                </div>
                <div className="text-sm text-gray-600 mt-1">בוצעו</div>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 shadow-lg border border-blue-200">
                <div className="text-3xl font-bold text-blue-600">
                  {sortedTimes.filter(time => {
                    const [hour, minute] = time.split(':');
                    const taskTime = `${hour}:${minute}`;
                    return taskTime >= currentTime && taskTime < `${parseInt(hour) + 1}:${minute}`;
                  }).length}
                </div>
                <div className="text-sm text-gray-600 mt-1">כרגע</div>
              </div>
              <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 shadow-lg border border-orange-200">
                <div className="text-3xl font-bold text-orange-600">
                  {sortedTimes.filter(time => time > currentTime).length}
                </div>
                <div className="text-sm text-gray-600 mt-1">בהמשך</div>
              </div>
            </div>
            
            {/* לו"ז היום */}
            <div className="bg-white rounded-2xl shadow-inner p-1">
              <div className="max-h-[500px] overflow-y-auto">
                {sortedTimes.map((time, index) => {
                  const task = allTasks[time];
                  const isPast = time < currentTime;
                  const isCurrent = time <= currentTime && 
                    sortedTimes[index + 1] && sortedTimes[index + 1] > currentTime;
                  
                  return (
<div 
  key={time}
  className={`flex items-stretch gap-0 border-b border-gray-100 last:border-0 transition-all hover:bg-gray-50 ${
    isCurrent ? 'bg-blue-50 shadow-lg ring-2 ring-blue-400 scale-[1.02]' : ''
  } ${isPast ? 'opacity-60' : ''}`}
>
  {/* זמן */}
  <div className={`w-24 px-4 py-4 flex items-center justify-center font-bold text-lg ${
    isCurrent ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'
  }`}>
    {time}
  </div>
  
  {/* משימה */}
  <div 
    className="flex-1 p-4 cursor-pointer"
    onClick={() => {
      if (task.id) {
        navigate(`/tasks/${task.id}`);
      }
    }}
  >
    <div className="flex items-center gap-3">
      {/* Checkbox - ללא רענון! */}
      <input
        type="checkbox"
        checked={taskCompletionStatus[`${time}-${task.id}`] ?? (task.status === 'הושלם' || task.completed === true)}
        onClick={(e) => {
          e.stopPropagation(); // מונע את הניווט
        }}
        onChange={(e) => {
          e.stopPropagation();
          const isCompleted = e.target.checked;
          
          // עדכון ה-state המקומי מיד
          setTaskCompletionStatus(prev => ({
            ...prev,
            [`${time}-${task.id}`]: isCompleted
          }));
          
          // עדכון ב-localStorage ברקע
          const dailyPlans = JSON.parse(localStorage.getItem('dailyPlans') || '[]');
          const todayPlan = dailyPlans.find(plan => 
            plan.date === today && 
            (plan.userId === currentUser?.id || plan.userName === currentUser?.name)
          );
          
          if (todayPlan) {
            Object.keys(todayPlan.schedule).forEach(scheduleTime => {
              if (todayPlan.schedule[scheduleTime]?.task?.id === task.id ||
                  todayPlan.schedule[scheduleTime]?.task?.title === task.title) {
                todayPlan.schedule[scheduleTime].task.status = isCompleted ? 'הושלם' : 'ממתין לעבודה';
                todayPlan.schedule[scheduleTime].task.completed = isCompleted;
              }
            });
            localStorage.setItem('dailyPlans', JSON.stringify(dailyPlans));
          }
          
          // עדכון בתכנון השבועי
          const weeklyPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
          weeklyPlans.forEach(plan => {
            if (plan.summaryData?.schedule) {
              Object.keys(plan.summaryData.schedule).forEach(dateStr => {
                if (plan.summaryData.schedule[dateStr]) {
                  Object.keys(plan.summaryData.schedule[dateStr]).forEach(timeKey => {
                    const weekTask = plan.summaryData.schedule[dateStr][timeKey];
                    if (weekTask && (weekTask.id === task.id || weekTask.title === task.title)) {
                      weekTask.status = isCompleted ? 'הושלם' : 'ממתין לעבודה';
                      weekTask.completed = isCompleted;
                    }
                  });
                }
              });
            }
          });
          localStorage.setItem('weeklyPlans', JSON.stringify(weeklyPlans));
          
          // אין רענון דף!
          console.log(`✅ משימה ${task.title} עודכנה ל-${isCompleted ? 'הושלמה' : 'לא הושלמה'}`);
        }}
        className="w-5 h-5 cursor-pointer accent-green-600"
      />
      
      {/* כותרת עם קו חוצה אם הושלם */}
      <h4 className={`font-semibold text-lg ${
        (taskCompletionStatus[`${time}-${task.id}`] ?? (task.status === 'הושלם' || task.completed))
          ? 'line-through text-gray-500' 
          : 'text-gray-900'
      }`}>
        {task.title}
      </h4>
      
      {/* תג סטטוס */}
      {(taskCompletionStatus[`${time}-${task.id}`] ?? (task.status === 'הושלם' || task.completed)) && (
        <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full">
          ✓ בוצע
        </span>
      )}
    </div>
  </div>
  
  {/* סטטוס */}
  <div className="w-32 flex items-center justify-center">
    {isPast ? (
      <CheckCircle className="w-8 h-8 text-green-500" />
    ) : isCurrent ? (
      <div className="animate-pulse">
        <Clock className="w-8 h-8 text-blue-500" />
      </div>
    ) : (
      <Clock className="w-8 h-8 text-gray-300" />
    )}
  </div>
</div>
                  );
                })}
              </div>
            </div>
            
            {/* ממשק עריכה מלא - רק במצב עריכה */}
            {isEditingCalendar && (
              <div className="mt-6 grid grid-cols-2 gap-6">
                {/* עמודה שמאלית - רשימת משימות */}
                <div className="bg-white rounded-2xl shadow-lg p-6 border-2 border-blue-200">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <CheckSquare className="w-6 h-6 text-blue-600" />
                    משימות זמינות
                  </h4>
                  
                  {/* סינון */}
                  <div className="mb-4 space-y-3">
                    <input
                      type="text"
                      placeholder="חפש משימה..."
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      onChange={(e) => {
                        const searchValue = e.target.value.toLowerCase();
                        const taskElements = document.querySelectorAll('[data-task-item]');
                        taskElements.forEach(el => {
                          const title = el.getAttribute('data-task-title').toLowerCase();
                          el.style.display = title.includes(searchValue) ? 'block' : 'none';
                        });
                      }}
                    />
                    
                    <div className="grid grid-cols-3 gap-2">
                      {/* פילטר המשימות שלי */}
                      <select
                        value={dailyFilterMyTasks ? 'my' : 'all'}
                        onChange={(e) => setDailyFilterMyTasks(e.target.value === 'my')}
                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm font-semibold"
                      >
                        <option value="my">המשימות שלי</option>
                        <option value="all">כל המשימות</option>
                      </select>
                      
                      {/* פילטר מחלקה */}
                      <select
                        value={dailyFilterDepartment}
                        onChange={(e) => setDailyFilterDepartment(e.target.value)}
                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                      >
                        <option value="">כל המחלקות</option>
                        {departments.map(dept => (
                          <option key={dept.id} value={dept.id}>{dept.name}</option>
                        ))}
                      </select>
                      
                      {/* פילטר פרויקט */}
                      <select
                        value={dailyFilterProject}
                        onChange={(e) => setDailyFilterProject(e.target.value)}
                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                      >
                        <option value="">כל הפרויקטים</option>
                        {projects.map(proj => (
                          <option key={proj.id} value={proj.id}>{proj.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  
                  {/* רשימת משימות עם drag */}
                  <div className="space-y-2 max-h-[600px] overflow-y-auto">
                    {tasks
                      .filter(task => !dailyFilterMyTasks || task.assignedTo === currentUser?.id || task.createdBy === currentUser?.id)
                      .filter(task => task.status !== 'הושלם')
                      .filter(task => !dailyFilterDepartment || task.departmentId === dailyFilterDepartment)
                      .filter(task => !dailyFilterProject || task.projectId === dailyFilterProject)
                      .map(task => (
                        <div
                          key={task.id}
                          data-task-item
                          data-task-title={task.title}
                          draggable
                          onDragStart={(e) => {
                            e.dataTransfer.setData('taskId', task.id);
                            e.dataTransfer.setData('taskData', JSON.stringify(task));
                          }}
                          className="p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl cursor-move hover:shadow-lg transition-all hover:scale-[1.02]"
                        >
                          <div className="flex items-center gap-2">
                            <div className="text-2xl">📋</div>
                            <div className="flex-1">
                              <h5 className="font-semibold text-gray-900">{task.title}</h5>
                              {task.description && (
                                <p className="text-sm text-gray-600 mt-1">{task.description.substring(0, 50)}...</p>
                              )}
                              <div className="flex gap-2 mt-2">
                                {task.priority && (
                                  <span className={`text-xs px-2 py-1 rounded-full ${
                                    task.priority === 'high' ? 'bg-red-100 text-red-700' :
                                    task.priority === 'medium' ? 'bg-yellow-100 text-yellow-700' :
                                    'bg-green-100 text-green-700'
                                  }`}>
                                    {task.priority === 'high' ? 'דחוף' : task.priority === 'medium' ? 'בינוני' : 'רגיל'}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
                
                {/* עמודה ימנית - לוח זמנים */}
                <div className="bg-white rounded-2xl shadow-lg p-6 border-2 border-green-200">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <Clock className="w-6 h-6 text-green-600" />
                    לוח זמנים - גרור משימות לכאן
                  </h4>
                  
                  <div className="space-y-1 max-h-[600px] overflow-y-auto">
                    {(() => {
                      const timeSlots = [];
                      for (let hour = 6; hour <= 21; hour++) {
                        ['00', '30'].forEach(minutes => {
                          timeSlots.push(`${String(hour).padStart(2, '0')}:${minutes}`);
                        });
                      }
                      
                      // חשב שעות חסומות
                      const blockedSlots = new Set();
                      Object.entries(editSchedule).forEach(([time, slot]) => {
                        if (slot && slot.duration) {
                          const duration = slot.duration;
                          const timeIndex = timeSlots.indexOf(time);
                          const slotsToBlock = Math.ceil(duration * 2) - 1; // כל שעה = 2 חצאי שעה
                          
                          for (let i = 1; i <= slotsToBlock && timeIndex + i < timeSlots.length; i++) {
                            blockedSlots.add(timeSlots[timeIndex + i]);
                          }
                        }
                      });
                      
                      return timeSlots.map(time => {
                        const existingTask = editSchedule[time];
                        const isBlocked = blockedSlots.has(time);
                        
                        return (
                          <div
                            key={time}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => {
                              e.preventDefault();
                              if (isBlocked) {
                                alert('❌ השעה הזו חסומה על ידי משימה אחרת!');
                                return;
                              }
                              
                              const taskData = JSON.parse(e.dataTransfer.getData('taskData'));
                              
                              // עדכן את editSchedule בלי רענון!
                              setEditSchedule(prev => ({
                                ...prev,
                                [time]: {
                                  task: taskData,
                                  duration: 1
                                }
                              }));
                            }}
                            className={`flex items-center gap-3 p-3 rounded-lg border-2 transition-all ${
                              existingTask 
                                ? 'bg-green-50 border-green-300' 
                                : isBlocked
                                ? 'bg-gray-100 border-gray-300 opacity-60'
                                : 'border-gray-200 hover:border-green-400 hover:bg-green-50'
                            }`}
                          >
                            <div className="w-20 text-center font-bold text-gray-700 bg-white rounded-lg px-2 py-1 border border-gray-300">
                              {time}
                            </div>
                            
                            {existingTask ? (
                              <div className="flex-1 flex items-center justify-between">
                                <div>
                                  <h5 className="font-semibold text-gray-900">{existingTask.task?.title}</h5>
                                  <div className="flex items-center gap-2 mt-1">
                                    <span className="text-xs text-gray-600">משך:</span>
                                    <div className="flex items-center gap-1 bg-white border border-gray-300 rounded-lg px-2 py-1">
                                      <button
                                        onClick={() => {
                                          const currentDuration = existingTask.duration || 1;
                                          if (currentDuration > 0.5) {
                                            setEditSchedule(prev => ({
                                              ...prev,
                                              [time]: {
                                                ...prev[time],
                                                duration: currentDuration - 0.5
                                              }
                                            }));
                                          }
                                        }}
                                        className="p-1 hover:bg-gray-100 rounded"
                                        title="הפחת חצי שעה"
                                      >
                                        <Minus className="w-3 h-3" />
                                      </button>
                                      <span className="text-sm font-bold px-2 min-w-[60px] text-center">
                                        {(() => {
                                          const dur = existingTask.duration || 1;
                                          if (dur === 0.5) return 'חצי';
                                          if (dur === 1) return 'שעה';
                                          if (dur === 1.5) return 'שעה וחצי';
                                          if (dur % 1 === 0.5) return `${Math.floor(dur)}½`;
                                          return `${dur} שעות`;
                                        })()}
                                      </span>
                                      <button
                                        onClick={() => {
                                          const currentDuration = existingTask.duration || 1;
                                          const timeIndex = timeSlots.indexOf(time);
                                          const nextSlotNeeded = timeIndex + Math.ceil(currentDuration * 2);
                                          
                                          // בדוק אם השעה הבאה פנויה
                                          if (nextSlotNeeded < timeSlots.length) {
                                            const nextTime = timeSlots[nextSlotNeeded];
                                            if (!editSchedule[nextTime] && !blockedSlots.has(nextTime)) {
                                              setEditSchedule(prev => ({
                                                ...prev,
                                                [time]: {
                                                  ...prev[time],
                                                  duration: currentDuration + 0.5
                                                }
                                              }));
                                            } else {
                                              alert('❌ לא ניתן להאריך - השעה הבאה תפוסה');
                                            }
                                          }
                                        }}
                                        className="p-1 hover:bg-gray-100 rounded"
                                        title="הוסף חצי שעה"
                                      >
                                        <Plus className="w-3 h-3" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <button
                                  onClick={() => {
                                    if (window.confirm('❌ למחוק משימה זו מהתכנון?')) {
                                      setEditSchedule(prev => {
                                        const newSchedule = {...prev};
                                        delete newSchedule[time];
                                        return newSchedule;
                                      });
                                    }
                                  }}
                                  className="px-3 py-2 bg-red-500 hover:bg-red-600 rounded-lg transition-all hover:scale-105 flex items-center gap-2 text-white font-medium shadow-md"
                                  title="מחק משימה"
                                >
                                  <Trash2 className="w-5 h-5" />
                                  <span className="text-sm">מחק</span>
                                </button>
                              </div>
                            ) : isBlocked ? (
                              <div className="flex-1 text-center text-gray-400 text-sm py-2 bg-gray-100 border-2 border-dashed border-gray-400 rounded-lg">
                                חסום (המשך משימה אחרת)
                              </div>
                            ) : (
                              <div className="flex-1 text-center text-gray-400 text-sm py-2 border-2 border-dashed border-gray-300 rounded-lg">
                                גרור משימה לכאן
                              </div>
                            )}
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              </div>
            )}
            
            {/* כפתורי פעולה */}
            <div className="mt-6 flex justify-center gap-4">
              {!isEditingCalendar ? (
                <>
                  <button
                    onClick={() => {
                      // טען את הלוח הנוכחי לעריכה
                      const today = new Date().toISOString().split('T')[0];
                      const dailyPlans = JSON.parse(localStorage.getItem('dailyPlans') || '[]');
                      const todayPlan = dailyPlans.find(plan => 
                        plan.date === today && 
                        (plan.userId === currentUser?.id || 
                         plan.userId === currentUser?.uid ||
                         plan.userName === currentUser?.name)
                      );
                      
                      setEditSchedule(todayPlan?.schedule || {});
                      setIsEditingCalendar(true);
                    }}
                    className="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl hover:from-blue-700 hover:to-indigo-700 font-semibold shadow-lg flex items-center gap-2"
                  >
                    <Edit2 className="w-5 h-5" />
                    ערוך תכנון יומי
                  </button>
                  <button
                    onClick={() => {
                      setEditPlanData(null);
                      setShowDailyPlanner(true);
                      setPlanningType('daily');
                    }}
                    className="px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl hover:from-green-700 hover:to-emerald-700 font-semibold shadow-lg flex items-center gap-2"
                  >
                    <Plus className="w-5 h-5" />
                    תכנון יומי מחדש
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => {
                      // פונקציה לסנכרון תכנון יומי לשבועי
                      const syncDailyToWeeklyPlan = (dailyPlan) => {
                        try {
                          const weeklyPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
                          const planDate = new Date(dailyPlan.date);
                          
                          // מצא את תחילת השבוע
                          const weekStart = new Date(planDate);
                          const day = weekStart.getDay();
                          weekStart.setDate(weekStart.getDate() - day);
                          const weekStartStr = weekStart.toISOString().split('T')[0];
                          
                          // מצא או צור תכנון שבועי
                          let weeklyPlanIndex = weeklyPlans.findIndex(p => 
                            (p.userId === currentUser?.id || p.userName === currentUser?.name) &&
                            p.summaryData?.weekStart === weekStartStr
                          );
                          
                          let weeklyPlan;
                          if (weeklyPlanIndex === -1) {
                            // צור תכנון שבועי חדש
                            weeklyPlan = {
                              id: Date.now().toString(),
                              userId: currentUser?.id,
                              userName: currentUser?.name,
                              savedAt: new Date().toISOString(),
                              type: 'weekly_planning',
                              summaryData: {
                                weekStart: weekStartStr,
                                schedule: {}
                              }
                            };
                            weeklyPlans.push(weeklyPlan);
                          } else {
                            weeklyPlan = weeklyPlans[weeklyPlanIndex];
                          }
                          
                          // הוסף/עדכן את המשימות היומיות בתכנון השבועי
                          if (!weeklyPlan.summaryData.schedule) {
                            weeklyPlan.summaryData.schedule = {};
                          }
                          
                          weeklyPlan.summaryData.schedule[dailyPlan.date] = {};
                          
                          Object.entries(dailyPlan.schedule).forEach(([time, slot]) => {
                            if (slot?.task) {
                              weeklyPlan.summaryData.schedule[dailyPlan.date][time] = {
                                ...slot.task,
                                duration: slot.duration || 1,
                                fromDailyPlan: true
                              };
                            }
                          });
                          
                          // שמור
                          localStorage.setItem('weeklyPlans', JSON.stringify(weeklyPlans));
                          console.log('✅ סונכרן עם תכנון שבועי');
                        } catch (error) {
                          console.error('Error syncing to weekly plan:', error);
                        }
                      };
                      
                      
                      // שמור את editSchedule ל-localStorage
                      const today = new Date().toISOString().split('T')[0];
                      const dailyPlans = JSON.parse(localStorage.getItem('dailyPlans') || '[]');
                      let todayPlanIndex = dailyPlans.findIndex(plan => 
                        plan.date === today && 
                        (plan.userId === currentUser?.id || 
                         plan.userId === currentUser?.uid ||
                         plan.userName === currentUser?.name)
                      );
                      
                      let todayPlan;
                      
                      // אם אין תכנון - צור אחד
                      if (todayPlanIndex === -1) {
                        todayPlan = {
                          id: Date.now().toString(),
                          date: today,
                          schedule: {},
                          selectedTasks: [],
                          dayNotes: '',
                          userId: currentUser?.id || currentUser?.uid,
                          userName: currentUser?.name,
                          userRole: currentUser?.role,
                          departmentId: currentUser?.departmentId,
                          departmentName: currentUser?.departmentName,
                          teamId: currentUser?.teamId,
                          teamName: currentUser?.teamName,
                          savedAt: new Date().toISOString(),
                          type: 'daily-plan',
                          category: 'plan',
                          summaryData: {
                            date: today,
                            totalTasks: 0,
                            scheduledSlots: 0,
                            dayNotes: ''
                          }
                        };
                        dailyPlans.push(todayPlan);
                      } else {
                        todayPlan = dailyPlans[todayPlanIndex];
                      }
                      
                      // עדכן את ה-schedule
                      todayPlan.schedule = editSchedule;
                      todayPlan.savedAt = new Date().toISOString();
                      
                      // חשב summaryData
                      const totalTasks = Object.keys(editSchedule).length;
                      todayPlan.summaryData = {
                        date: today,
                        totalTasks: totalTasks,
                        scheduledSlots: totalTasks,
                        dayNotes: todayPlan.dayNotes || ''
                      };
                      
                      // שמור
                      localStorage.setItem('dailyPlans', JSON.stringify(dailyPlans));
                      
                      console.log('💾 תכנון נשמר:', todayPlan);
                      console.log('📅 Schedule:', todayPlan.schedule);
                      
                      // סנכרן לתכנון שבועי
                      syncDailyToWeeklyPlan(todayPlan);
                      
                      alert(`✅ התכנון נשמר בהצלחה!\n${totalTasks} משימות נשמרו.`);
                      setIsEditingCalendar(false);
                      window.location.reload();
                    }}
                    className="px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl hover:from-green-700 hover:to-emerald-700 font-semibold shadow-lg flex items-center gap-2"
                  >
                    <Save className="w-5 h-5" />
                    סיים עריכה
                  </button>
                  <button
                    onClick={() => {
                      if (window.confirm('האם לבטל את השינויים?')) {
                        setIsEditingCalendar(false);
                        setEditSchedule({});
                      }
                    }}
                    className="px-6 py-3 bg-gray-500 text-white rounded-xl hover:bg-gray-600 font-semibold shadow-lg flex items-center gap-2"
                  >
                    <X className="w-5 h-5" />
                    ביטול
                  </button>
                </>
              )}
              <button
                onClick={() => window.print()}
                className="px-6 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 font-semibold"
              >
                🖨️ הדפס לו"ז
              </button>
            </div>
          </div>
        );
      })()}
    </div>
  </div>
</div>

        {/* Notes Section - FIXED PERMISSIONS */}
        <div className="mt-8">
          <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20">
            <div className="p-8 border-b border-gray-100/50 bg-gradient-to-r from-purple-50/50 to-pink-50/50">
              <h3 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                הערות על משימות
              </h3>
              <p className="text-gray-600 mt-2 text-lg">
                הערות על המשימות שלך ✨
              </p>
              <div className="mt-3 p-4 bg-blue-50/50 rounded-xl border border-blue-200/50">
                <p className="text-sm text-blue-800">
                  <strong>הרשאות הערות:</strong> רק יוצר המשימה רואה הערות שנוספו למשימה שלו
                </p>
              </div>
            </div>
            
            <div className="p-8">
              {/* Comments on tasks I created */}
              <div className="mb-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl text-white">
                    <MessageSquare className="w-5 h-5" />
                  </div>
                  הערות על המשימות שיצרתי
                </h4>
                
                {/* Display comments on tasks created by current user */}
                <div className="space-y-4">
                  {tasks
                    .filter(task => task.createdBy === currentUser?.id && task.comments && task.comments.length > 0)
                    .slice(0, 10)
                    .map(task => {
                      const taskComments = task.comments || [];
                      return taskComments.map((comment, index) => {
                        const commentAuthor = users.find(u => u.id === comment.authorId);
                        
                        return (
                          <div 
                            key={`${task.id}-${index}`} 
                            className="bg-gray-50/80 backdrop-blur-sm rounded-2xl p-6 border border-gray-200/50 transition-all duration-200 cursor-pointer hover:bg-gray-100/80"
                            onClick={() => handleNavigateToTask(task.id)}
                          >
                            <div className="flex items-start justify-between mb-3">
                              <div className="flex items-center gap-3">
                                <div className="p-2 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl text-white">
                                  <User className="w-4 h-4" />
                                </div>
                                <div>
                                  <h5 className="font-semibold text-gray-900">
                                    {commentAuthor ? commentAuthor.name : 'משתמש לא ידוע'}
                                    {comment.authorId === currentUser?.id && (
                                      <span className="text-blue-600 text-xs mr-2">(אני)</span>
                                    )}
                                  </h5>
                                  <p className="text-sm text-gray-600">
                                    על המשימה: <span className="text-blue-600 font-medium">{task.title}</span>
                                  </p>
                                </div>
                              </div>
                              <span className="text-xs text-gray-500">
                                {comment.createdAt ? new Date(comment.createdAt).toLocaleDateString('he-IL') : 'תאריך לא ידוע'}
                              </span>
                            </div>
                            <p className="text-gray-700 leading-relaxed">
                              {comment.text}
                            </p>
                          </div>
                        );
                      });
                    })
                    .flat()}

                  {/* If no comments on created tasks */}
                  {tasks.filter(task => 
                    task.createdBy === currentUser?.id && 
                    task.comments && 
                    task.comments.length > 0
                  ).length === 0 && (
                    <div className="text-center py-8 text-gray-500">
                      <MessageSquare className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                      <p>אין הערות על המשימות שיצרת</p>
                    </div>
                  )}
                </div>
              </div>

              {/* CEO Additional Notes - Only for CEO */}
              {currentUser?.role === 'org_admin' && (
                <div className="border-t border-gray-200/50 pt-8">
                  <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-3">
                    <div className="p-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl text-white">
                      <Crown className="w-5 h-5" />
                    </div>
                    הערות מנכ"ל
                  </h4>
                  <textarea
                    value={ceoNotes}
                    onChange={(e) => setCeoNotes(e.target.value)}
                    placeholder="הוסף הערות מנהליות חשובות..."
                    className="w-full p-6 border border-gray-200/50 rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-purple-50/50 backdrop-blur-sm transition-all duration-200"
                    rows={4}
                  />
                  <div className="mt-4 flex justify-end">
                    <button 
                      onClick={handleSaveCeoNotes}
                      className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-600 text-white rounded-2xl hover:from-purple-600 hover:to-pink-700 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl hover:scale-105"
                    >
                      שמור הערות מנכ"ל
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
{showDailyPlanner && (
  <DailyPlanner 
    onClose={() => {
      setShowDailyPlanner(false);
      setIsAddingToExisting(false);
      setPlanningType('daily');
      setEditPlanData(null);
      // רענן את הלוח אחרי סגירה
      loadWeeklySchedule(currentWeekStart);
    }}
    initialPlanningType={planningType}
    isAddingToExisting={isAddingToExisting}
    editPlanData={{
      ...editPlanData,
      summaryData: {
        ...editPlanData?.summaryData,
        schedule: weeklyScheduleState // העבר את ה-state העדכני!
      }
    }}
    currentWeek={currentWeekStart}
  />
)}
    </div>
  );
};

// קומפוננטה פנימית ללוח השבועי
const WeeklyCalendarDisplay = ({ 
  currentWeekStart, 
  currentUser, 
  isEditingCalendar,
  weeklyScheduleState,
  setWeeklyScheduleState,
  handleNavigateToTask 
}) => {
  const [draggedTask, setDraggedTask] = useState(null);
  
  // חישוב תחילת השבוע
  const weekStartDate = new Date(currentWeekStart);
  const day = weekStartDate.getDay();
  if (day !== 0) {
    weekStartDate.setDate(weekStartDate.getDate() - day);
  }
  const weekStartStr = weekStartDate.toISOString().split('T')[0];
  
  // טעינת הלוח מה-state הגלובלי
  const localSchedule = weeklyScheduleState;
  
const saveScheduleToStorage = (newSchedule) => {
  // חישוב תחילת השבוע
  const weekStartDate = new Date(currentWeekStart);
  const day = weekStartDate.getDay();
  if (day !== 0) {
    weekStartDate.setDate(weekStartDate.getDate() - day);
  }
  const weekStartStr = weekStartDate.toISOString().split('T')[0];
  
  // טעינת תכנונים קיימים
  const plans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
  const planIndex = plans.findIndex(p => 
    (p.userId === currentUser?.id || p.userName === currentUser?.name) &&
    p.summaryData?.weekStart === weekStartStr
  );
  
  if (planIndex >= 0) {
    // עדכון תכנון קיים
    plans[planIndex].summaryData.schedule = newSchedule;
    plans[planIndex].updatedAt = new Date().toISOString();
  } else {
    // יצירת תכנון חדש
    plans.push({
      id: Date.now().toString(),
      userId: currentUser?.id,
      userName: currentUser?.name,
      savedAt: new Date().toISOString(),
      type: 'weekly_planning',
      summaryData: {
        weekStart: weekStartStr,
        schedule: newSchedule
      }
    });
  }
  
  // שמירה ב-localStorage
  localStorage.setItem('weeklyPlans', JSON.stringify(plans));
  
  // עדכון ה-state הגלובלי מיד!
  setWeeklyScheduleState(newSchedule);
  
  // במקום loadWeeklySchedule - פשוט טען מחדש ישירות
  setTimeout(() => {
    const updatedPlans = JSON.parse(localStorage.getItem('weeklyPlans') || '[]');
    const updatedPlan = updatedPlans.find(p => 
      (p.userId === currentUser?.id || p.userName === currentUser?.name) &&
      p.summaryData?.weekStart === weekStartStr
    );
    
    if (updatedPlan?.summaryData?.schedule) {
      setWeeklyScheduleState(updatedPlan.summaryData.schedule);
    }
  }, 100);
  
  console.log('✅ נשמר ב-localStorage וה-state עודכן');
};
  
  // דראג אנד דרופ
  const handleDragStart = (e, task, dateStr, timeSlot) => {
    if (!isEditingCalendar) return;
    setDraggedTask({ task, dateStr, timeSlot });
    e.dataTransfer.effectAllowed = 'move';
  };
  
  const handleDragOver = (e) => {
    if (!isEditingCalendar) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };
  
  const handleDrop = (e, newDateStr, newTimeSlot) => {
    e.preventDefault();
    if (!isEditingCalendar || !draggedTask) return;
    
    const { task, dateStr: oldDateStr, timeSlot: oldTimeSlot } = draggedTask;
    
    // בדיקה שהמקום פנוי
    if (localSchedule[newDateStr]?.[newTimeSlot]) {
      alert('המיקום תפוס! בחר מקום פנוי.');
      return;
    }
    
    // עדכון הלוח
    const updatedSchedule = { ...localSchedule };
    
    // הסרה מהמיקום הישן
    if (updatedSchedule[oldDateStr]) {
      delete updatedSchedule[oldDateStr][oldTimeSlot];
    }
    
    // הוספה למיקום החדש
    if (!updatedSchedule[newDateStr]) {
      updatedSchedule[newDateStr] = {};
    }
    updatedSchedule[newDateStr][newTimeSlot] = task;
    
    // עדכון state ושמירה
    saveScheduleToStorage(updatedSchedule);
    setDraggedTask(null);
  };
  
  // יצירת תאריכי השבוע
  const weekDates = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(weekStartDate);
    date.setDate(weekStartDate.getDate() + i);
    weekDates.push(date);
  }
  
  return (
    <div className="bg-white rounded-2xl overflow-hidden">
      {/* כותרת עם תאריכים */}
      <div className="grid grid-cols-8 gap-0 bg-gray-50 border-b-2 border-gray-200">
        <div className="p-4 text-center border-r border-gray-200">
          <Clock className="w-5 h-5 mx-auto mb-1 text-gray-600" />
          <span className="text-sm font-bold">שעה</span>
        </div>
        {['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'].map((dayName, index) => {
          const date = weekDates[index];
          const isToday = date.toDateString() === new Date().toDateString();
          return (
            <div key={index} className={`p-4 text-center border-r border-gray-200 ${
              isToday ? 'bg-blue-100' : ''
            }`}>
              <div className="font-bold text-sm">{dayName}</div>
              <div className="text-xs text-gray-600">
                {date.getDate()}/{date.getMonth() + 1}
              </div>
              {isToday && (
                <div className="text-xs text-blue-600 font-bold">(היום)</div>
              )}
            </div>
          );
        })}
      </div>
      
      {/* שעות ומשימות */}
      <div className="max-h-[600px] overflow-y-auto">
   {['06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', 
  '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', 
  '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', 
  '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', 
  '22:00'].map(timeSlot => (
          <div key={timeSlot} className="grid grid-cols-8 gap-0 border-b border-gray-200">
            <div className="p-3 text-center bg-gray-50 border-r border-gray-200">
              <span className="text-sm font-medium">{timeSlot}</span>
            </div>
            {weekDates.map((date, dayIndex) => {
              const dateStr = date.toISOString().split('T')[0];
              const task = localSchedule[dateStr]?.[timeSlot];
              const isToday = date.toDateString() === new Date().toDateString();
              
              return (
                <div 
                  key={dayIndex} 
                  className={`p-2 min-h-[60px] border-r border-gray-200 ${
                    isToday ? 'bg-blue-50/30' : 'bg-white'
                  } ${isEditingCalendar ? 'hover:bg-gray-100' : ''}`}
                  onDragOver={handleDragOver}
                  onDrop={(e) => handleDrop(e, dateStr, timeSlot)}
                >
                  {task && task.title && (
                    <div 
                      draggable={isEditingCalendar}
                      onDragStart={(e) => handleDragStart(e, task, dateStr, timeSlot)}
                      className={`p-2 rounded-lg text-xs hover:shadow-md transition-all ${
                        isEditingCalendar ? 'cursor-move' : 'cursor-pointer'
                      } ${
                        task.priority === 'high' ? 'bg-red-100 border border-red-300 text-red-800' :
                        task.priority === 'medium' ? 'bg-yellow-100 border border-yellow-300 text-yellow-800' :
                        'bg-green-100 border border-green-300 text-green-800'
                      }`}
                      onClick={() => {
                        if (!isEditingCalendar && task.id) {
                          handleNavigateToTask(task.id);
                        }
                      }}
                    >
                      <div className="font-bold truncate">{task.title}</div>
                      {task.project && (
                        <div className="text-xs opacity-75 mt-1 truncate">{task.project}</div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
      
      {/* סיכום */}
      <div className="p-4 bg-gray-50 border-t-2 border-gray-200">
        <div className="text-sm text-gray-600">
          סה"כ משימות השבוע: <span className="font-bold text-lg text-blue-600">
            {Object.values(localSchedule).reduce((total, day) => 
              total + Object.values(day || {}).filter(t => t && t.title).length, 0
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ManagerialDashboard;